
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lvw85", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa856a796bae9135$export$2e2bcd8739ae039);

var $a5SNS = parcelRequire("a5SNS");

var $dFEOL = parcelRequire("dFEOL");

var $iWFzb = parcelRequire("iWFzb");

var $gdglj = parcelRequire("gdglj");

var $itw5b = parcelRequire("itw5b");

var $iqhNc = parcelRequire("iqhNc");

var $9tKZs = parcelRequire("9tKZs");

var $5BkkP = parcelRequire("5BkkP");

var $4x8BI = parcelRequire("4x8BI");

var $kvjOh = parcelRequire("kvjOh");

var $jI3be = parcelRequire("jI3be");

var $do6DE = parcelRequire("do6DE");

var $8TA2O = parcelRequire("8TA2O");

var $46cdq = parcelRequire("46cdq");

var $8kCjH = parcelRequire("8kCjH");

var $jEYPr = parcelRequire("jEYPr");

var $jVKfz = parcelRequire("jVKfz");

var $2GSBL = parcelRequire("2GSBL");

var $3PWre = parcelRequire("3PWre");

var $5VZP3 = parcelRequire("5VZP3");

var $gwsDR = parcelRequire("gwsDR");

var $3MRPo = parcelRequire("3MRPo");

var $gkzBz = parcelRequire("gkzBz");

var $lGJ7D = parcelRequire("lGJ7D");

var $6tBRD = parcelRequire("6tBRD");

var $h2pi1 = parcelRequire("h2pi1");

var $hgZvN = parcelRequire("hgZvN");

var $5LEQd = parcelRequire("5LEQd");

var $eeTZS = parcelRequire("eeTZS");

var $3FYBi = parcelRequire("3FYBi");

var $j1VIk = parcelRequire("j1VIk");
(0, $a5SNS.default).register({
    'attributors/attribute/direction': (0, $iWFzb.DirectionAttribute),
    'attributors/class/align': (0, $dFEOL.AlignClass),
    'attributors/class/background': (0, $5BkkP.BackgroundClass),
    'attributors/class/color': (0, $4x8BI.ColorClass),
    'attributors/class/direction': (0, $iWFzb.DirectionClass),
    'attributors/class/font': (0, $kvjOh.FontClass),
    'attributors/class/size': (0, $jI3be.SizeClass),
    'attributors/style/align': (0, $dFEOL.AlignStyle),
    'attributors/style/background': (0, $5BkkP.BackgroundStyle),
    'attributors/style/color': (0, $4x8BI.ColorStyle),
    'attributors/style/direction': (0, $iWFzb.DirectionStyle),
    'attributors/style/font': (0, $kvjOh.FontStyle),
    'attributors/style/size': (0, $jI3be.SizeStyle)
}, true);
(0, $a5SNS.default).register({
    'formats/align': (0, $dFEOL.AlignClass),
    'formats/direction': (0, $iWFzb.DirectionClass),
    'formats/indent': (0, $gdglj.default),
    'formats/background': (0, $5BkkP.BackgroundStyle),
    'formats/color': (0, $4x8BI.ColorStyle),
    'formats/font': (0, $kvjOh.FontClass),
    'formats/size': (0, $jI3be.SizeClass),
    'formats/blockquote': (0, $itw5b.default),
    'formats/code-block': (0, $gwsDR.default),
    'formats/header': (0, $iqhNc.default),
    'formats/list': (0, $9tKZs.default),
    'formats/bold': (0, $do6DE.default),
    'formats/code': (0, $gwsDR.Code),
    'formats/italic': (0, $8TA2O.default),
    'formats/link': (0, $46cdq.default),
    'formats/script': (0, $8kCjH.default),
    'formats/strike': (0, $jEYPr.default),
    'formats/underline': (0, $jVKfz.default),
    'formats/formula': (0, $2GSBL.default),
    'formats/image': (0, $3PWre.default),
    'formats/video': (0, $5VZP3.default),
    'modules/syntax': (0, $3MRPo.default),
    'modules/table': (0, $gkzBz.default),
    'modules/toolbar': (0, $lGJ7D.default),
    'themes/bubble': (0, $3FYBi.default),
    'themes/snow': (0, $j1VIk.default),
    'ui/icons': (0, $6tBRD.default),
    'ui/picker': (0, $h2pi1.default),
    'ui/icon-picker': (0, $5LEQd.default),
    'ui/color-picker': (0, $hgZvN.default),
    'ui/tooltip': (0, $eeTZS.default)
}, true);
var $fa856a796bae9135$export$2e2bcd8739ae039 = (0, $a5SNS.default);

});
parcelRegister("a5SNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7594e1da9bf628e2$export$2e2bcd8739ae039);

var $lcQXp = parcelRequire("lcQXp");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $em4Pe = parcelRequire("em4Pe");

var $luQs7 = parcelRequire("luQs7");

var $9xp90 = parcelRequire("9xp90");

var $fWwa7 = parcelRequire("fWwa7");

var $03ycQ = parcelRequire("03ycQ");

var $bxVMH = parcelRequire("bxVMH");

var $lkNmd = parcelRequire("lkNmd");

var $jrSqt = parcelRequire("jrSqt");

var $lRlaz = parcelRequire("lRlaz");

var $5OX8I = parcelRequire("5OX8I");

var $kEXGb = parcelRequire("kEXGb");

var $ccFIq = parcelRequire("ccFIq");

var $7wMGU = parcelRequire("7wMGU");

var $5APNb = parcelRequire("5APNb");
(0, $lcQXp.default).register({
    'blots/block': (0, $fp1Tt.default),
    'blots/block/embed': (0, $fp1Tt.BlockEmbed),
    'blots/break': (0, $bmwCM.default),
    'blots/container': (0, $em4Pe.default),
    'blots/cursor': (0, $luQs7.default),
    'blots/embed': (0, $9xp90.default),
    'blots/inline': (0, $fWwa7.default),
    'blots/scroll': (0, $03ycQ.default),
    'blots/text': (0, $bxVMH.default),
    'modules/clipboard': (0, $lkNmd.default),
    'modules/history': (0, $jrSqt.default),
    'modules/keyboard': (0, $lRlaz.default),
    'modules/uploader': (0, $5OX8I.default),
    'modules/input': (0, $ccFIq.default),
    'modules/uiNode': (0, $7wMGU.default)
});
var $7594e1da9bf628e2$export$2e2bcd8739ae039 = (0, $lcQXp.default);

});
parcelRegister("lcQXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f703cc29143734d2$export$2e2bcd8739ae039);

var $4exCq = parcelRequire("4exCq");

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $bLz0Y = parcelRequire("bLz0Y");

var $jJqnr = parcelRequire("jJqnr");

var $bp7pN = parcelRequire("bp7pN");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");

var $3EdO3 = parcelRequire("3EdO3");

var $gjzF2 = parcelRequire("gjzF2");

var $c7e5N = parcelRequire("c7e5N");

var $bb4Dz = parcelRequire("bb4Dz");

var $f3rcF = parcelRequire("f3rcF");
const $f703cc29143734d2$var$debug = (0, $lkbqq.default)('quill');
const $f703cc29143734d2$export$bc58ce2776ecdb6f = new $lHwOS.Registry();
$lHwOS.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $f703cc29143734d2$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $f703cc29143734d2$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $jJqnr.default).events;
    static sources = (0, $jJqnr.default).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb))),
        parchment: $lHwOS,
        'core/module': (0, $5APNb.default),
        'core/theme': (0, $c7e5N.default)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $lkbqq.default).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $bp7pN.default).get(node) || $f703cc29143734d2$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $f703cc29143734d2$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $f703cc29143734d2$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $f703cc29143734d2$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($f703cc29143734d2$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $f703cc29143734d2$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $f703cc29143734d2$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $f703cc29143734d2$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $bp7pN.default).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $jJqnr.default)();
        const scrollBlotName = $lHwOS.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $bLz0Y.default)(this.scroll);
        this.selection = new (0, $3EdO3.default)(this.scroll, this.emitter);
        this.composition = new (0, $gjzF2.default)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $jJqnr.default).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $jJqnr.default).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $f703cc29143734d2$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $f703cc29143734d2$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $f703cc29143734d2$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $jJqnr.default).sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
            if (range == null) return change;
            if (this.scroll.query(name, $lHwOS.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $jJqnr.default).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $f703cc29143734d2$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $f703cc29143734d2$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $f703cc29143734d2$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $f703cc29143734d2$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $f703cc29143734d2$export$2e2bcd8739ae039.sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $f703cc29143734d2$export$e336952123c0bccd(index, 0, name, value, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, source);
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $bb4Dz.default)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $jJqnr.default).sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $f703cc29143734d2$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $f703cc29143734d2$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $3EdO3.Range)(Math.max(0, index), length), source);
            if (source !== (0, $jJqnr.default).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $jJqnr.default).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $jJqnr.default).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $jJqnr.default).sources.API;
        return $f703cc29143734d2$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $f703cc29143734d2$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $f703cc29143734d2$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $f703cc29143734d2$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $f703cc29143734d2$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $f703cc29143734d2$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $f703cc29143734d2$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $c7e5N.default) : $f703cc29143734d2$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $f703cc29143734d2$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $f703cc29143734d2$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $4exCq.default)({}, $f703cc29143734d2$var$expandModuleConfig(quillModuleDefaults), $f703cc29143734d2$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$f703cc29143734d2$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$f703cc29143734d2$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $f703cc29143734d2$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $f3rcF.default)(options.formats, config.registry, $f703cc29143734d2$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $f703cc29143734d2$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $f703cc29143734d2$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $4exCq.default)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $f703cc29143734d2$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $f703cc29143734d2$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $jJqnr.default).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $f703cc29143734d2$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $f703cc29143734d2$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $jJqnr.default).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $jJqnr.default).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $jJqnr.default).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $jJqnr.default).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $f703cc29143734d2$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $jJqnr.default).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $f703cc29143734d2$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $jJqnr.default).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $jJqnr.default).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $3EdO3.Range)(start, end - start);
}

});
parcelRegister("4exCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $31528c3235d11c78$export$2e2bcd8739ae039);

var $9n4xL = parcelRequire("9n4xL");

var $1jwcU = parcelRequire("1jwcU");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $31528c3235d11c78$var$merge = (0, $1jwcU.default)(function(object, source, srcIndex) {
    (0, $9n4xL.default)(object, source, srcIndex);
});
var $31528c3235d11c78$export$2e2bcd8739ae039 = $31528c3235d11c78$var$merge;

});
parcelRegister("9n4xL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d29c9473147a495$export$2e2bcd8739ae039);

var $ch4ws = parcelRequire("ch4ws");

var $fa9ZF = parcelRequire("fa9ZF");

var $1gEEJ = parcelRequire("1gEEJ");

var $ce9Ft = parcelRequire("ce9Ft");

var $kXXxV = parcelRequire("kXXxV");

var $fIbiK = parcelRequire("fIbiK");

var $g7yOx = parcelRequire("g7yOx");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $6d29c9473147a495$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $1gEEJ.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $ch4ws.default));
        if ((0, $kXXxV.default)(srcValue)) (0, $ce9Ft.default)(object, source, key, srcIndex, $6d29c9473147a495$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $g7yOx.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $fa9ZF.default)(object, key, newValue);
        }
    }, (0, $fIbiK.default));
}
var $6d29c9473147a495$export$2e2bcd8739ae039 = $6d29c9473147a495$var$baseMerge;

});
parcelRegister("ch4ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $024e5d3c6325761d$export$2e2bcd8739ae039);

var $aG4ch = parcelRequire("aG4ch");

var $bUZ6i = parcelRequire("bUZ6i");

var $dZk6F = parcelRequire("dZk6F");

var $jRWRF = parcelRequire("jRWRF");

var $g3MUc = parcelRequire("g3MUc");

var $6M0L8 = parcelRequire("6M0L8");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $024e5d3c6325761d$var$Stack(entries) {
    var data = this.__data__ = new (0, $aG4ch.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$024e5d3c6325761d$var$Stack.prototype.clear = (0, $bUZ6i.default);
$024e5d3c6325761d$var$Stack.prototype['delete'] = (0, $dZk6F.default);
$024e5d3c6325761d$var$Stack.prototype.get = (0, $jRWRF.default);
$024e5d3c6325761d$var$Stack.prototype.has = (0, $g3MUc.default);
$024e5d3c6325761d$var$Stack.prototype.set = (0, $6M0L8.default);
var $024e5d3c6325761d$export$2e2bcd8739ae039 = $024e5d3c6325761d$var$Stack;

});
parcelRegister("aG4ch", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6115142bbd100f$export$2e2bcd8739ae039);

var $6vLWY = parcelRequire("6vLWY");

var $jUnPr = parcelRequire("jUnPr");

var $1vLhu = parcelRequire("1vLhu");

var $9IMvv = parcelRequire("9IMvv");

var $4J4Ti = parcelRequire("4J4Ti");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7c6115142bbd100f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$7c6115142bbd100f$var$ListCache.prototype.clear = (0, $6vLWY.default);
$7c6115142bbd100f$var$ListCache.prototype['delete'] = (0, $jUnPr.default);
$7c6115142bbd100f$var$ListCache.prototype.get = (0, $1vLhu.default);
$7c6115142bbd100f$var$ListCache.prototype.has = (0, $9IMvv.default);
$7c6115142bbd100f$var$ListCache.prototype.set = (0, $4J4Ti.default);
var $7c6115142bbd100f$export$2e2bcd8739ae039 = $7c6115142bbd100f$var$ListCache;

});
parcelRegister("6vLWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bdad542d9db6cc0$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4bdad542d9db6cc0$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $4bdad542d9db6cc0$export$2e2bcd8739ae039 = $4bdad542d9db6cc0$var$listCacheClear;

});

parcelRegister("jUnPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e5bb262cb888fb$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/** Used for built-in method references. */ var $e7e5bb262cb888fb$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e7e5bb262cb888fb$var$splice = $e7e5bb262cb888fb$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e7e5bb262cb888fb$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $3jgi6.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e7e5bb262cb888fb$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $e7e5bb262cb888fb$export$2e2bcd8739ae039 = $e7e5bb262cb888fb$var$listCacheDelete;

});
parcelRegister("3jgi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $268fc8793075bd8e$export$2e2bcd8739ae039);

var $78Lr5 = parcelRequire("78Lr5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $268fc8793075bd8e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $78Lr5.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $268fc8793075bd8e$export$2e2bcd8739ae039 = $268fc8793075bd8e$var$assocIndexOf;

});
parcelRegister("78Lr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $532e138903529660$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $532e138903529660$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $532e138903529660$export$2e2bcd8739ae039 = $532e138903529660$var$eq;

});



parcelRegister("1vLhu", function(module, exports) {

$parcel$export(module.exports, "default", () => $119d5cbce7b236be$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $119d5cbce7b236be$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $3jgi6.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $119d5cbce7b236be$export$2e2bcd8739ae039 = $119d5cbce7b236be$var$listCacheGet;

});

parcelRegister("9IMvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $713dd99bab35ecdc$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $713dd99bab35ecdc$var$listCacheHas(key) {
    return (0, $3jgi6.default)(this.__data__, key) > -1;
}
var $713dd99bab35ecdc$export$2e2bcd8739ae039 = $713dd99bab35ecdc$var$listCacheHas;

});

parcelRegister("4J4Ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $370f28a386fb97f7$export$2e2bcd8739ae039);

var $3jgi6 = parcelRequire("3jgi6");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $370f28a386fb97f7$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $3jgi6.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $370f28a386fb97f7$export$2e2bcd8739ae039 = $370f28a386fb97f7$var$listCacheSet;

});


parcelRegister("bUZ6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad451fd7b83d8a3$export$2e2bcd8739ae039);

var $aG4ch = parcelRequire("aG4ch");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $8ad451fd7b83d8a3$var$stackClear() {
    this.__data__ = new (0, $aG4ch.default);
    this.size = 0;
}
var $8ad451fd7b83d8a3$export$2e2bcd8739ae039 = $8ad451fd7b83d8a3$var$stackClear;

});

parcelRegister("dZk6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f0919cd5192709$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a2f0919cd5192709$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $a2f0919cd5192709$export$2e2bcd8739ae039 = $a2f0919cd5192709$var$stackDelete;

});

parcelRegister("jRWRF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e770a0dce54723de$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e770a0dce54723de$var$stackGet(key) {
    return this.__data__.get(key);
}
var $e770a0dce54723de$export$2e2bcd8739ae039 = $e770a0dce54723de$var$stackGet;

});

parcelRegister("g3MUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb12dcc533c9fdbc$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bb12dcc533c9fdbc$var$stackHas(key) {
    return this.__data__.has(key);
}
var $bb12dcc533c9fdbc$export$2e2bcd8739ae039 = $bb12dcc533c9fdbc$var$stackHas;

});

parcelRegister("6M0L8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ee7d08a3b77c208$export$2e2bcd8739ae039);

var $aG4ch = parcelRequire("aG4ch");

var $fHOWn = parcelRequire("fHOWn");

var $j9mMr = parcelRequire("j9mMr");
/** Used as the size to enable large array optimizations. */ var $4ee7d08a3b77c208$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $4ee7d08a3b77c208$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $aG4ch.default)) {
        var pairs = data.__data__;
        if (!(0, $fHOWn.default) || pairs.length < $4ee7d08a3b77c208$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $j9mMr.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $4ee7d08a3b77c208$export$2e2bcd8739ae039 = $4ee7d08a3b77c208$var$stackSet;

});
parcelRegister("fHOWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f262e5e80108d9$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $b6f262e5e80108d9$var$Map = (0, $8dB7s.default)((0, $2ZUhy.default), 'Map');
var $b6f262e5e80108d9$export$2e2bcd8739ae039 = $b6f262e5e80108d9$var$Map;

});
parcelRegister("8dB7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fbc54bb4011da38$export$2e2bcd8739ae039);

var $ap7Bn = parcelRequire("ap7Bn");

var $ftBHs = parcelRequire("ftBHs");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5fbc54bb4011da38$var$getNative(object, key) {
    var value = (0, $ftBHs.default)(object, key);
    return (0, $ap7Bn.default)(value) ? value : undefined;
}
var $5fbc54bb4011da38$export$2e2bcd8739ae039 = $5fbc54bb4011da38$var$getNative;

});
parcelRegister("ap7Bn", function(module, exports) {

$parcel$export(module.exports, "default", () => $793222ba65e3682a$export$2e2bcd8739ae039);

var $8WSEV = parcelRequire("8WSEV");

var $dcqCR = parcelRequire("dcqCR");

var $kXXxV = parcelRequire("kXXxV");

var $gu9fH = parcelRequire("gu9fH");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $793222ba65e3682a$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $793222ba65e3682a$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $793222ba65e3682a$var$funcProto = Function.prototype, $793222ba65e3682a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $793222ba65e3682a$var$funcToString = $793222ba65e3682a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $793222ba65e3682a$var$hasOwnProperty = $793222ba65e3682a$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $793222ba65e3682a$var$reIsNative = RegExp('^' + $793222ba65e3682a$var$funcToString.call($793222ba65e3682a$var$hasOwnProperty).replace($793222ba65e3682a$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $793222ba65e3682a$var$baseIsNative(value) {
    if (!(0, $kXXxV.default)(value) || (0, $dcqCR.default)(value)) return false;
    var pattern = (0, $8WSEV.default)(value) ? $793222ba65e3682a$var$reIsNative : $793222ba65e3682a$var$reIsHostCtor;
    return pattern.test((0, $gu9fH.default)(value));
}
var $793222ba65e3682a$export$2e2bcd8739ae039 = $793222ba65e3682a$var$baseIsNative;

});
parcelRegister("8WSEV", function(module, exports) {

$parcel$export(module.exports, "default", () => $683e23aa99ebf6cc$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $kXXxV = parcelRequire("kXXxV");
/** `Object#toString` result references. */ var $683e23aa99ebf6cc$var$asyncTag = '[object AsyncFunction]', $683e23aa99ebf6cc$var$funcTag = '[object Function]', $683e23aa99ebf6cc$var$genTag = '[object GeneratorFunction]', $683e23aa99ebf6cc$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $683e23aa99ebf6cc$var$isFunction(value) {
    if (!(0, $kXXxV.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $f4sy6.default)(value);
    return tag == $683e23aa99ebf6cc$var$funcTag || tag == $683e23aa99ebf6cc$var$genTag || tag == $683e23aa99ebf6cc$var$asyncTag || tag == $683e23aa99ebf6cc$var$proxyTag;
}
var $683e23aa99ebf6cc$export$2e2bcd8739ae039 = $683e23aa99ebf6cc$var$isFunction;

});

parcelRegister("dcqCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c10caa3b1bf583$export$2e2bcd8739ae039);

var $gQtST = parcelRequire("gQtST");
/** Used to detect methods masquerading as native. */ var $99c10caa3b1bf583$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gQtST.default) && (0, $gQtST.default).keys && (0, $gQtST.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $99c10caa3b1bf583$var$isMasked(func) {
    return !!$99c10caa3b1bf583$var$maskSrcKey && $99c10caa3b1bf583$var$maskSrcKey in func;
}
var $99c10caa3b1bf583$export$2e2bcd8739ae039 = $99c10caa3b1bf583$var$isMasked;

});
parcelRegister("gQtST", function(module, exports) {

$parcel$export(module.exports, "default", () => $c438af103151eccd$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");
/** Used to detect overreaching core-js shims. */ var $c438af103151eccd$var$coreJsData = (0, $2ZUhy.default)['__core-js_shared__'];
var $c438af103151eccd$export$2e2bcd8739ae039 = $c438af103151eccd$var$coreJsData;

});


parcelRegister("gu9fH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0069ff645d76721$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $c0069ff645d76721$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c0069ff645d76721$var$funcToString = $c0069ff645d76721$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c0069ff645d76721$var$toSource(func) {
    if (func != null) {
        try {
            return $c0069ff645d76721$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $c0069ff645d76721$export$2e2bcd8739ae039 = $c0069ff645d76721$var$toSource;

});


parcelRegister("ftBHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b446ced8aaebeb76$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b446ced8aaebeb76$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $b446ced8aaebeb76$export$2e2bcd8739ae039 = $b446ced8aaebeb76$var$getValue;

});



parcelRegister("j9mMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $df10874410dc9ccf$export$2e2bcd8739ae039);

var $5lO2c = parcelRequire("5lO2c");

var $lBMRq = parcelRequire("lBMRq");

var $6i4Wx = parcelRequire("6i4Wx");

var $kP85e = parcelRequire("kP85e");

var $67Et0 = parcelRequire("67Et0");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $df10874410dc9ccf$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$df10874410dc9ccf$var$MapCache.prototype.clear = (0, $5lO2c.default);
$df10874410dc9ccf$var$MapCache.prototype['delete'] = (0, $lBMRq.default);
$df10874410dc9ccf$var$MapCache.prototype.get = (0, $6i4Wx.default);
$df10874410dc9ccf$var$MapCache.prototype.has = (0, $kP85e.default);
$df10874410dc9ccf$var$MapCache.prototype.set = (0, $67Et0.default);
var $df10874410dc9ccf$export$2e2bcd8739ae039 = $df10874410dc9ccf$var$MapCache;

});
parcelRegister("5lO2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e55b9bb47f2bbd0$export$2e2bcd8739ae039);

var $5IPv1 = parcelRequire("5IPv1");

var $aG4ch = parcelRequire("aG4ch");

var $fHOWn = parcelRequire("fHOWn");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $3e55b9bb47f2bbd0$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $5IPv1.default),
        'map': new ((0, $fHOWn.default) || (0, $aG4ch.default)),
        'string': new (0, $5IPv1.default)
    };
}
var $3e55b9bb47f2bbd0$export$2e2bcd8739ae039 = $3e55b9bb47f2bbd0$var$mapCacheClear;

});
parcelRegister("5IPv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a902825fae1889$export$2e2bcd8739ae039);

var $d5eW8 = parcelRequire("d5eW8");

var $2iHSP = parcelRequire("2iHSP");

var $8fXzA = parcelRequire("8fXzA");

var $fgg7G = parcelRequire("fgg7G");

var $8acEK = parcelRequire("8acEK");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $42a902825fae1889$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$42a902825fae1889$var$Hash.prototype.clear = (0, $d5eW8.default);
$42a902825fae1889$var$Hash.prototype['delete'] = (0, $2iHSP.default);
$42a902825fae1889$var$Hash.prototype.get = (0, $8fXzA.default);
$42a902825fae1889$var$Hash.prototype.has = (0, $fgg7G.default);
$42a902825fae1889$var$Hash.prototype.set = (0, $8acEK.default);
var $42a902825fae1889$export$2e2bcd8739ae039 = $42a902825fae1889$var$Hash;

});
parcelRegister("d5eW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9867541cb5dac3ef$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $9867541cb5dac3ef$var$hashClear() {
    this.__data__ = (0, $61TQK.default) ? (0, $61TQK.default)(null) : {};
    this.size = 0;
}
var $9867541cb5dac3ef$export$2e2bcd8739ae039 = $9867541cb5dac3ef$var$hashClear;

});
parcelRegister("61TQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $463e28aa276cb787$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");
/* Built-in method references that are verified to be native. */ var $463e28aa276cb787$var$nativeCreate = (0, $8dB7s.default)(Object, 'create');
var $463e28aa276cb787$export$2e2bcd8739ae039 = $463e28aa276cb787$var$nativeCreate;

});


parcelRegister("2iHSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acf4d8250d69dd9$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1acf4d8250d69dd9$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $1acf4d8250d69dd9$export$2e2bcd8739ae039 = $1acf4d8250d69dd9$var$hashDelete;

});

parcelRegister("8fXzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $602def647adec634$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/** Used to stand-in for `undefined` hash values. */ var $602def647adec634$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $602def647adec634$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $602def647adec634$var$hasOwnProperty = $602def647adec634$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $602def647adec634$var$hashGet(key) {
    var data = this.__data__;
    if (0, $61TQK.default) {
        var result = data[key];
        return result === $602def647adec634$var$HASH_UNDEFINED ? undefined : result;
    }
    return $602def647adec634$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $602def647adec634$export$2e2bcd8739ae039 = $602def647adec634$var$hashGet;

});

parcelRegister("fgg7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c4db4c990b2ea5$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/** Used for built-in method references. */ var $b1c4db4c990b2ea5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b1c4db4c990b2ea5$var$hasOwnProperty = $b1c4db4c990b2ea5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b1c4db4c990b2ea5$var$hashHas(key) {
    var data = this.__data__;
    return (0, $61TQK.default) ? data[key] !== undefined : $b1c4db4c990b2ea5$var$hasOwnProperty.call(data, key);
}
var $b1c4db4c990b2ea5$export$2e2bcd8739ae039 = $b1c4db4c990b2ea5$var$hashHas;

});

parcelRegister("8acEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0188a9998b3c27e6$export$2e2bcd8739ae039);

var $61TQK = parcelRequire("61TQK");
/** Used to stand-in for `undefined` hash values. */ var $0188a9998b3c27e6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $0188a9998b3c27e6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $61TQK.default) && value === undefined ? $0188a9998b3c27e6$var$HASH_UNDEFINED : value;
    return this;
}
var $0188a9998b3c27e6$export$2e2bcd8739ae039 = $0188a9998b3c27e6$var$hashSet;

});



parcelRegister("lBMRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb2f467985a4f81$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fbb2f467985a4f81$var$mapCacheDelete(key) {
    var result = (0, $dsxLI.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $fbb2f467985a4f81$export$2e2bcd8739ae039 = $fbb2f467985a4f81$var$mapCacheDelete;

});
parcelRegister("dsxLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc8159e5ed69efe$export$2e2bcd8739ae039);

var $aaVA2 = parcelRequire("aaVA2");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $9cc8159e5ed69efe$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $aaVA2.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $9cc8159e5ed69efe$export$2e2bcd8739ae039 = $9cc8159e5ed69efe$var$getMapData;

});
parcelRegister("aaVA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768780c93ac19bf2$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $768780c93ac19bf2$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $768780c93ac19bf2$export$2e2bcd8739ae039 = $768780c93ac19bf2$var$isKeyable;

});



parcelRegister("6i4Wx", function(module, exports) {

$parcel$export(module.exports, "default", () => $49484220c3a992e5$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $49484220c3a992e5$var$mapCacheGet(key) {
    return (0, $dsxLI.default)(this, key).get(key);
}
var $49484220c3a992e5$export$2e2bcd8739ae039 = $49484220c3a992e5$var$mapCacheGet;

});

parcelRegister("kP85e", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28ed73c0d93261f$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f28ed73c0d93261f$var$mapCacheHas(key) {
    return (0, $dsxLI.default)(this, key).has(key);
}
var $f28ed73c0d93261f$export$2e2bcd8739ae039 = $f28ed73c0d93261f$var$mapCacheHas;

});

parcelRegister("67Et0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4752c95eb7794262$export$2e2bcd8739ae039);

var $dsxLI = parcelRequire("dsxLI");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $4752c95eb7794262$var$mapCacheSet(key, value) {
    var data = (0, $dsxLI.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $4752c95eb7794262$export$2e2bcd8739ae039 = $4752c95eb7794262$var$mapCacheSet;

});




parcelRegister("fa9ZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b09f8ab906eab8aa$export$2e2bcd8739ae039);

var $bWSGY = parcelRequire("bWSGY");

var $78Lr5 = parcelRequire("78Lr5");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b09f8ab906eab8aa$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $78Lr5.default)(object[key], value) || value === undefined && !(key in object)) (0, $bWSGY.default)(object, key, value);
}
var $b09f8ab906eab8aa$export$2e2bcd8739ae039 = $b09f8ab906eab8aa$var$assignMergeValue;

});
parcelRegister("bWSGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b2f8934178fcc6a$export$2e2bcd8739ae039);

var $cfI3G = parcelRequire("cfI3G");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $8b2f8934178fcc6a$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $cfI3G.default)) (0, $cfI3G.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $8b2f8934178fcc6a$export$2e2bcd8739ae039 = $8b2f8934178fcc6a$var$baseAssignValue;

});
parcelRegister("cfI3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eb90fd6adb57b5f$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");
var $8eb90fd6adb57b5f$var$defineProperty = function() {
    try {
        var func = (0, $8dB7s.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $8eb90fd6adb57b5f$export$2e2bcd8739ae039 = $8eb90fd6adb57b5f$var$defineProperty;

});



parcelRegister("1gEEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec6d281b8e95206$export$2e2bcd8739ae039);

var $bYQjx = parcelRequire("bYQjx");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $0ec6d281b8e95206$var$baseFor = (0, $bYQjx.default)();
var $0ec6d281b8e95206$export$2e2bcd8739ae039 = $0ec6d281b8e95206$var$baseFor;

});
parcelRegister("bYQjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8de0cf760e2676$export$2e2bcd8739ae039);
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $8b8de0cf760e2676$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $8b8de0cf760e2676$export$2e2bcd8739ae039 = $8b8de0cf760e2676$var$createBaseFor;

});


parcelRegister("ce9Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6e4aab838488a1$export$2e2bcd8739ae039);

var $fa9ZF = parcelRequire("fa9ZF");

var $imxSd = parcelRequire("imxSd");

var $70ZJW = parcelRequire("70ZJW");

var $6x0q0 = parcelRequire("6x0q0");

var $hMPMN = parcelRequire("hMPMN");

var $ebAE7 = parcelRequire("ebAE7");

var $hXn90 = parcelRequire("hXn90");

var $icZJv = parcelRequire("icZJv");

var $hiJJV = parcelRequire("hiJJV");

var $8WSEV = parcelRequire("8WSEV");

var $kXXxV = parcelRequire("kXXxV");

var $bOFVz = parcelRequire("bOFVz");

var $ckYSa = parcelRequire("ckYSa");

var $g7yOx = parcelRequire("g7yOx");

var $eCWAz = parcelRequire("eCWAz");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $8e6e4aab838488a1$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $g7yOx.default)(object, key), srcValue = (0, $g7yOx.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $fa9ZF.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $hXn90.default)(srcValue), isBuff = !isArr && (0, $hiJJV.default)(srcValue), isTyped = !isArr && !isBuff && (0, $ckYSa.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $hXn90.default)(objValue)) newValue = objValue;
            else if ((0, $icZJv.default)(objValue)) newValue = (0, $6x0q0.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $imxSd.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $70ZJW.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $bOFVz.default)(srcValue) || (0, $ebAE7.default)(srcValue)) {
            newValue = objValue;
            if ((0, $ebAE7.default)(objValue)) newValue = (0, $eCWAz.default)(objValue);
            else if (!(0, $kXXxV.default)(objValue) || (0, $8WSEV.default)(objValue)) newValue = (0, $hMPMN.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $fa9ZF.default)(object, key, newValue);
}
var $8e6e4aab838488a1$export$2e2bcd8739ae039 = $8e6e4aab838488a1$var$baseMergeDeep;

});
parcelRegister("imxSd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e48ea47ae18000$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2ZUhy.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $d5e48ea47ae18000$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("70ZJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b86cbfdf253641$export$2e2bcd8739ae039);

var $aal8n = parcelRequire("aal8n");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $51b86cbfdf253641$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $aal8n.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $51b86cbfdf253641$export$2e2bcd8739ae039 = $51b86cbfdf253641$var$cloneTypedArray;

});
parcelRegister("aal8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $766b3b5c1b005675$export$2e2bcd8739ae039);

var $7uREm = parcelRequire("7uREm");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $766b3b5c1b005675$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $7uREm.default)(result).set(new (0, $7uREm.default)(arrayBuffer));
    return result;
}
var $766b3b5c1b005675$export$2e2bcd8739ae039 = $766b3b5c1b005675$var$cloneArrayBuffer;

});
parcelRegister("7uREm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5754f38924ac1fdd$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");
/** Built-in value references. */ var $5754f38924ac1fdd$var$Uint8Array = (0, $2ZUhy.default).Uint8Array;
var $5754f38924ac1fdd$export$2e2bcd8739ae039 = $5754f38924ac1fdd$var$Uint8Array;

});



parcelRegister("6x0q0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c162636d6c60380$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $4c162636d6c60380$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $4c162636d6c60380$export$2e2bcd8739ae039 = $4c162636d6c60380$var$copyArray;

});

parcelRegister("hMPMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2f16f8d1cd5b3d$export$2e2bcd8739ae039);

var $acO6k = parcelRequire("acO6k");

var $lPOv3 = parcelRequire("lPOv3");

var $7H3cd = parcelRequire("7H3cd");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $cf2f16f8d1cd5b3d$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $7H3cd.default)(object) ? (0, $acO6k.default)((0, $lPOv3.default)(object)) : {};
}
var $cf2f16f8d1cd5b3d$export$2e2bcd8739ae039 = $cf2f16f8d1cd5b3d$var$initCloneObject;

});
parcelRegister("acO6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e1e36434315ed3$export$2e2bcd8739ae039);

var $kXXxV = parcelRequire("kXXxV");
/** Built-in value references. */ var $76e1e36434315ed3$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $76e1e36434315ed3$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $kXXxV.default)(proto)) return {};
        if ($76e1e36434315ed3$var$objectCreate) return $76e1e36434315ed3$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $76e1e36434315ed3$export$2e2bcd8739ae039 = $76e1e36434315ed3$var$baseCreate;

});

parcelRegister("lPOv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe558899101fb74c$export$2e2bcd8739ae039);

var $3knOV = parcelRequire("3knOV");
/** Built-in value references. */ var $fe558899101fb74c$var$getPrototype = (0, $3knOV.default)(Object.getPrototypeOf, Object);
var $fe558899101fb74c$export$2e2bcd8739ae039 = $fe558899101fb74c$var$getPrototype;

});
parcelRegister("3knOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c5b79670c770f2$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $26c5b79670c770f2$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $26c5b79670c770f2$export$2e2bcd8739ae039 = $26c5b79670c770f2$var$overArg;

});


parcelRegister("7H3cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $599f0731d714e584$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $599f0731d714e584$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $599f0731d714e584$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $599f0731d714e584$var$objectProto;
    return value === proto;
}
var $599f0731d714e584$export$2e2bcd8739ae039 = $599f0731d714e584$var$isPrototype;

});


parcelRegister("ebAE7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a53e84e52eaf8a5a$export$2e2bcd8739ae039);

var $hAmYU = parcelRequire("hAmYU");

var $ydcRw = parcelRequire("ydcRw");
/** Used for built-in method references. */ var $a53e84e52eaf8a5a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a53e84e52eaf8a5a$var$hasOwnProperty = $a53e84e52eaf8a5a$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $a53e84e52eaf8a5a$var$propertyIsEnumerable = $a53e84e52eaf8a5a$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $a53e84e52eaf8a5a$var$isArguments = (0, $hAmYU.default)(function() {
    return arguments;
}()) ? (0, $hAmYU.default) : function(value) {
    return (0, $ydcRw.default)(value) && $a53e84e52eaf8a5a$var$hasOwnProperty.call(value, 'callee') && !$a53e84e52eaf8a5a$var$propertyIsEnumerable.call(value, 'callee');
};
var $a53e84e52eaf8a5a$export$2e2bcd8739ae039 = $a53e84e52eaf8a5a$var$isArguments;

});
parcelRegister("hAmYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd7a014d1bcafef$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $ccd7a014d1bcafef$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ccd7a014d1bcafef$var$baseIsArguments(value) {
    return (0, $ydcRw.default)(value) && (0, $f4sy6.default)(value) == $ccd7a014d1bcafef$var$argsTag;
}
var $ccd7a014d1bcafef$export$2e2bcd8739ae039 = $ccd7a014d1bcafef$var$baseIsArguments;

});


parcelRegister("hXn90", function(module, exports) {

$parcel$export(module.exports, "default", () => $d129e6568a5c9a2e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d129e6568a5c9a2e$var$isArray = Array.isArray;
var $d129e6568a5c9a2e$export$2e2bcd8739ae039 = $d129e6568a5c9a2e$var$isArray;

});

parcelRegister("icZJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4193bdfe2397598$export$2e2bcd8739ae039);

var $8pHBa = parcelRequire("8pHBa");

var $ydcRw = parcelRequire("ydcRw");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $d4193bdfe2397598$var$isArrayLikeObject(value) {
    return (0, $ydcRw.default)(value) && (0, $8pHBa.default)(value);
}
var $d4193bdfe2397598$export$2e2bcd8739ae039 = $d4193bdfe2397598$var$isArrayLikeObject;

});
parcelRegister("8pHBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $62027a42d464cbbf$export$2e2bcd8739ae039);

var $8WSEV = parcelRequire("8WSEV");

var $fpNby = parcelRequire("fpNby");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $62027a42d464cbbf$var$isArrayLike(value) {
    return value != null && (0, $fpNby.default)(value.length) && !(0, $8WSEV.default)(value);
}
var $62027a42d464cbbf$export$2e2bcd8739ae039 = $62027a42d464cbbf$var$isArrayLike;

});
parcelRegister("fpNby", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38f57fe9b1971bb$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $b38f57fe9b1971bb$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $b38f57fe9b1971bb$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $b38f57fe9b1971bb$var$MAX_SAFE_INTEGER;
}
var $b38f57fe9b1971bb$export$2e2bcd8739ae039 = $b38f57fe9b1971bb$var$isLength;

});



parcelRegister("hiJJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c987991464247417$export$2e2bcd8739ae039);

var $2ZUhy = parcelRequire("2ZUhy");

var $iE4IL = parcelRequire("iE4IL");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2ZUhy.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $iE4IL.default);
var $c987991464247417$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("iE4IL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d92f9fef287f6869$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $d92f9fef287f6869$var$stubFalse() {
    return false;
}
var $d92f9fef287f6869$export$2e2bcd8739ae039 = $d92f9fef287f6869$var$stubFalse;

});


parcelRegister("bOFVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a4e328099889b2$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $lPOv3 = parcelRequire("lPOv3");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $89a4e328099889b2$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $89a4e328099889b2$var$funcProto = Function.prototype, $89a4e328099889b2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $89a4e328099889b2$var$funcToString = $89a4e328099889b2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $89a4e328099889b2$var$hasOwnProperty = $89a4e328099889b2$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $89a4e328099889b2$var$objectCtorString = $89a4e328099889b2$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $89a4e328099889b2$var$isPlainObject(value) {
    if (!(0, $ydcRw.default)(value) || (0, $f4sy6.default)(value) != $89a4e328099889b2$var$objectTag) return false;
    var proto = (0, $lPOv3.default)(value);
    if (proto === null) return true;
    var Ctor = $89a4e328099889b2$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $89a4e328099889b2$var$funcToString.call(Ctor) == $89a4e328099889b2$var$objectCtorString;
}
var $89a4e328099889b2$export$2e2bcd8739ae039 = $89a4e328099889b2$var$isPlainObject;

});

parcelRegister("ckYSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb692530855fc35$export$2e2bcd8739ae039);

var $euZ8c = parcelRequire("euZ8c");

var $i0Jgc = parcelRequire("i0Jgc");

var $lAe6g = parcelRequire("lAe6g");
/* Node.js helper references. */ var $8fb692530855fc35$var$nodeIsTypedArray = (0, $lAe6g.default) && (0, $lAe6g.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8fb692530855fc35$var$isTypedArray = $8fb692530855fc35$var$nodeIsTypedArray ? (0, $i0Jgc.default)($8fb692530855fc35$var$nodeIsTypedArray) : (0, $euZ8c.default);
var $8fb692530855fc35$export$2e2bcd8739ae039 = $8fb692530855fc35$var$isTypedArray;

});
parcelRegister("euZ8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e349708fb24653$export$2e2bcd8739ae039);

var $f4sy6 = parcelRequire("f4sy6");

var $fpNby = parcelRequire("fpNby");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $a8e349708fb24653$var$argsTag = '[object Arguments]', $a8e349708fb24653$var$arrayTag = '[object Array]', $a8e349708fb24653$var$boolTag = '[object Boolean]', $a8e349708fb24653$var$dateTag = '[object Date]', $a8e349708fb24653$var$errorTag = '[object Error]', $a8e349708fb24653$var$funcTag = '[object Function]', $a8e349708fb24653$var$mapTag = '[object Map]', $a8e349708fb24653$var$numberTag = '[object Number]', $a8e349708fb24653$var$objectTag = '[object Object]', $a8e349708fb24653$var$regexpTag = '[object RegExp]', $a8e349708fb24653$var$setTag = '[object Set]', $a8e349708fb24653$var$stringTag = '[object String]', $a8e349708fb24653$var$weakMapTag = '[object WeakMap]';
var $a8e349708fb24653$var$arrayBufferTag = '[object ArrayBuffer]', $a8e349708fb24653$var$dataViewTag = '[object DataView]', $a8e349708fb24653$var$float32Tag = '[object Float32Array]', $a8e349708fb24653$var$float64Tag = '[object Float64Array]', $a8e349708fb24653$var$int8Tag = '[object Int8Array]', $a8e349708fb24653$var$int16Tag = '[object Int16Array]', $a8e349708fb24653$var$int32Tag = '[object Int32Array]', $a8e349708fb24653$var$uint8Tag = '[object Uint8Array]', $a8e349708fb24653$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a8e349708fb24653$var$uint16Tag = '[object Uint16Array]', $a8e349708fb24653$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a8e349708fb24653$var$typedArrayTags = {};
$a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$float32Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$float64Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$int8Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$int16Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$int32Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint8Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint8ClampedTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint16Tag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$uint32Tag] = true;
$a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$argsTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$arrayTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$arrayBufferTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$boolTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$dataViewTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$dateTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$errorTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$funcTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$mapTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$numberTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$objectTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$regexpTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$setTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$stringTag] = $a8e349708fb24653$var$typedArrayTags[$a8e349708fb24653$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a8e349708fb24653$var$baseIsTypedArray(value) {
    return (0, $ydcRw.default)(value) && (0, $fpNby.default)(value.length) && !!$a8e349708fb24653$var$typedArrayTags[(0, $f4sy6.default)(value)];
}
var $a8e349708fb24653$export$2e2bcd8739ae039 = $a8e349708fb24653$var$baseIsTypedArray;

});

parcelRegister("i0Jgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1cb55d2b1225f37$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d1cb55d2b1225f37$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $d1cb55d2b1225f37$export$2e2bcd8739ae039 = $d1cb55d2b1225f37$var$baseUnary;

});

parcelRegister("lAe6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb67e5bd130cd129$export$2e2bcd8739ae039);

var $eEY6y = parcelRequire("eEY6y");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $eEY6y.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $fb67e5bd130cd129$export$2e2bcd8739ae039 = nodeUtil;

});


parcelRegister("g7yOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc84e2c2a83f7db$export$2e2bcd8739ae039);
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $bbc84e2c2a83f7db$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $bbc84e2c2a83f7db$export$2e2bcd8739ae039 = $bbc84e2c2a83f7db$var$safeGet;

});

parcelRegister("eCWAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02bf84625a8b8755$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $fIbiK = parcelRequire("fIbiK");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $02bf84625a8b8755$var$toPlainObject(value) {
    return (0, $8Up13.default)(value, (0, $fIbiK.default)(value));
}
var $02bf84625a8b8755$export$2e2bcd8739ae039 = $02bf84625a8b8755$var$toPlainObject;

});
parcelRegister("8Up13", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c6f55e9e7fb040$export$2e2bcd8739ae039);

var $kYkm0 = parcelRequire("kYkm0");

var $bWSGY = parcelRequire("bWSGY");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $67c6f55e9e7fb040$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $bWSGY.default)(object, key, newValue);
        else (0, $kYkm0.default)(object, key, newValue);
    }
    return object;
}
var $67c6f55e9e7fb040$export$2e2bcd8739ae039 = $67c6f55e9e7fb040$var$copyObject;

});
parcelRegister("kYkm0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f449331fcce2b408$export$2e2bcd8739ae039);

var $bWSGY = parcelRequire("bWSGY");

var $78Lr5 = parcelRequire("78Lr5");
/** Used for built-in method references. */ var $f449331fcce2b408$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f449331fcce2b408$var$hasOwnProperty = $f449331fcce2b408$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f449331fcce2b408$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($f449331fcce2b408$var$hasOwnProperty.call(object, key) && (0, $78Lr5.default)(objValue, value)) || value === undefined && !(key in object)) (0, $bWSGY.default)(object, key, value);
}
var $f449331fcce2b408$export$2e2bcd8739ae039 = $f449331fcce2b408$var$assignValue;

});


parcelRegister("fIbiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b703bb51de33f3da$export$2e2bcd8739ae039);

var $fuUH8 = parcelRequire("fuUH8");

var $6mi2A = parcelRequire("6mi2A");

var $8pHBa = parcelRequire("8pHBa");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $b703bb51de33f3da$var$keysIn(object) {
    return (0, $8pHBa.default)(object) ? (0, $fuUH8.default)(object, true) : (0, $6mi2A.default)(object);
}
var $b703bb51de33f3da$export$2e2bcd8739ae039 = $b703bb51de33f3da$var$keysIn;

});
parcelRegister("fuUH8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b485a2c4081a5d7a$export$2e2bcd8739ae039);

var $ds54F = parcelRequire("ds54F");

var $ebAE7 = parcelRequire("ebAE7");

var $hXn90 = parcelRequire("hXn90");

var $hiJJV = parcelRequire("hiJJV");

var $g3KRC = parcelRequire("g3KRC");

var $ckYSa = parcelRequire("ckYSa");
/** Used for built-in method references. */ var $b485a2c4081a5d7a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b485a2c4081a5d7a$var$hasOwnProperty = $b485a2c4081a5d7a$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b485a2c4081a5d7a$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hXn90.default)(value), isArg = !isArr && (0, $ebAE7.default)(value), isBuff = !isArr && !isArg && (0, $hiJJV.default)(value), isType = !isArr && !isArg && !isBuff && (0, $ckYSa.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $ds54F.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b485a2c4081a5d7a$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $g3KRC.default)(key, length)))) result.push(key);
    return result;
}
var $b485a2c4081a5d7a$export$2e2bcd8739ae039 = $b485a2c4081a5d7a$var$arrayLikeKeys;

});
parcelRegister("ds54F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb1d388d31961ff$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $9cb1d388d31961ff$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $9cb1d388d31961ff$export$2e2bcd8739ae039 = $9cb1d388d31961ff$var$baseTimes;

});

parcelRegister("g3KRC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb1147505a697450$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $bb1147505a697450$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $bb1147505a697450$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $bb1147505a697450$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $bb1147505a697450$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $bb1147505a697450$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $bb1147505a697450$export$2e2bcd8739ae039 = $bb1147505a697450$var$isIndex;

});


parcelRegister("6mi2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a12caaf9a168473$export$2e2bcd8739ae039);

var $kXXxV = parcelRequire("kXXxV");

var $7H3cd = parcelRequire("7H3cd");

var $kXLw9 = parcelRequire("kXLw9");
/** Used for built-in method references. */ var $4a12caaf9a168473$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4a12caaf9a168473$var$hasOwnProperty = $4a12caaf9a168473$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4a12caaf9a168473$var$baseKeysIn(object) {
    if (!(0, $kXXxV.default)(object)) return (0, $kXLw9.default)(object);
    var isProto = (0, $7H3cd.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$4a12caaf9a168473$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $4a12caaf9a168473$export$2e2bcd8739ae039 = $4a12caaf9a168473$var$baseKeysIn;

});
parcelRegister("kXLw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42e2d565706b6d4$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f42e2d565706b6d4$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $f42e2d565706b6d4$export$2e2bcd8739ae039 = $f42e2d565706b6d4$var$nativeKeysIn;

});






parcelRegister("1jwcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f508c7875557669$export$2e2bcd8739ae039);

var $e5ePl = parcelRequire("e5ePl");

var $bPTtD = parcelRequire("bPTtD");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $0f508c7875557669$var$createAssigner(assigner) {
    return (0, $e5ePl.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $bPTtD.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $0f508c7875557669$export$2e2bcd8739ae039 = $0f508c7875557669$var$createAssigner;

});
parcelRegister("e5ePl", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a55f1ba864368b$export$2e2bcd8739ae039);

var $fktFl = parcelRequire("fktFl");

var $3LRzs = parcelRequire("3LRzs");

var $6iyEc = parcelRequire("6iyEc");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $02a55f1ba864368b$var$baseRest(func, start) {
    return (0, $6iyEc.default)((0, $3LRzs.default)(func, start, (0, $fktFl.default)), func + '');
}
var $02a55f1ba864368b$export$2e2bcd8739ae039 = $02a55f1ba864368b$var$baseRest;

});
parcelRegister("fktFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28fbc494eeb3145$export$2e2bcd8739ae039);
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $b28fbc494eeb3145$var$identity(value) {
    return value;
}
var $b28fbc494eeb3145$export$2e2bcd8739ae039 = $b28fbc494eeb3145$var$identity;

});

parcelRegister("3LRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bef50f13d973928$export$2e2bcd8739ae039);

var $g4av9 = parcelRequire("g4av9");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2bef50f13d973928$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $2bef50f13d973928$var$overRest(func, start, transform) {
    start = $2bef50f13d973928$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $2bef50f13d973928$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $g4av9.default)(func, this, otherArgs);
    };
}
var $2bef50f13d973928$export$2e2bcd8739ae039 = $2bef50f13d973928$var$overRest;

});
parcelRegister("g4av9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb252a691659aeb8$export$2e2bcd8739ae039);
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $bb252a691659aeb8$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $bb252a691659aeb8$export$2e2bcd8739ae039 = $bb252a691659aeb8$var$apply;

});


parcelRegister("6iyEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $495f4cc291d9adf3$export$2e2bcd8739ae039);

var $8CIs9 = parcelRequire("8CIs9");

var $k4rRt = parcelRequire("k4rRt");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $495f4cc291d9adf3$var$setToString = (0, $k4rRt.default)((0, $8CIs9.default));
var $495f4cc291d9adf3$export$2e2bcd8739ae039 = $495f4cc291d9adf3$var$setToString;

});
parcelRegister("8CIs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $64745acdfc17e50f$export$2e2bcd8739ae039);

var $74LjD = parcelRequire("74LjD");

var $cfI3G = parcelRequire("cfI3G");

var $fktFl = parcelRequire("fktFl");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $64745acdfc17e50f$var$baseSetToString = !(0, $cfI3G.default) ? (0, $fktFl.default) : function(func, string) {
    return (0, $cfI3G.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $74LjD.default)(string),
        'writable': true
    });
};
var $64745acdfc17e50f$export$2e2bcd8739ae039 = $64745acdfc17e50f$var$baseSetToString;

});
parcelRegister("74LjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $526d9c0a5c43b886$export$2e2bcd8739ae039);
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $526d9c0a5c43b886$var$constant(value) {
    return function() {
        return value;
    };
}
var $526d9c0a5c43b886$export$2e2bcd8739ae039 = $526d9c0a5c43b886$var$constant;

});


parcelRegister("k4rRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c9cb134a523c22$export$2e2bcd8739ae039);
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $e9c9cb134a523c22$var$HOT_COUNT = 800, $e9c9cb134a523c22$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e9c9cb134a523c22$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $e9c9cb134a523c22$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $e9c9cb134a523c22$var$nativeNow(), remaining = $e9c9cb134a523c22$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $e9c9cb134a523c22$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $e9c9cb134a523c22$export$2e2bcd8739ae039 = $e9c9cb134a523c22$var$shortOut;

});



parcelRegister("bPTtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $89df7db7ae630b98$export$2e2bcd8739ae039);

var $78Lr5 = parcelRequire("78Lr5");

var $8pHBa = parcelRequire("8pHBa");

var $g3KRC = parcelRequire("g3KRC");

var $kXXxV = parcelRequire("kXXxV");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $89df7db7ae630b98$var$isIterateeCall(value, index, object) {
    if (!(0, $kXXxV.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $8pHBa.default)(object) && (0, $g3KRC.default)(index, object.length) : type == 'string' && index in object) return (0, $78Lr5.default)(object[index], value);
    return false;
}
var $89df7db7ae630b98$export$2e2bcd8739ae039 = $89df7db7ae630b98$var$isIterateeCall;

});



parcelRegister("lHwOS", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $fcc7126f4809333a$export$775b6bb06e53a214);
$parcel$export(module.exports, "Attributor", () => $fcc7126f4809333a$export$217610c4183502d0);
$parcel$export(module.exports, "Registry", () => $fcc7126f4809333a$export$4d9facee29974f3);
$parcel$export(module.exports, "ClassAttributor", () => $fcc7126f4809333a$export$651d45509677cf07);
$parcel$export(module.exports, "StyleAttributor", () => $fcc7126f4809333a$export$7c8099bbfe87b94d);
$parcel$export(module.exports, "AttributorStore", () => $fcc7126f4809333a$export$68ad86ab95e8de42);
$parcel$export(module.exports, "LeafBlot", () => $fcc7126f4809333a$export$7420b9c542181544);
$parcel$export(module.exports, "ParentBlot", () => $fcc7126f4809333a$export$e43113f0aad76fe);
$parcel$export(module.exports, "InlineBlot", () => $fcc7126f4809333a$export$f67a34bc25a7a861);
$parcel$export(module.exports, "BlockBlot", () => $fcc7126f4809333a$export$4f7f03641f7bfc8c);
$parcel$export(module.exports, "ContainerBlot", () => $fcc7126f4809333a$export$c898d510319704c0);
$parcel$export(module.exports, "EmbedBlot", () => $fcc7126f4809333a$export$297a1fa96f55f00f);
$parcel$export(module.exports, "ScrollBlot", () => $fcc7126f4809333a$export$7175329dad7a46f1);
$parcel$export(module.exports, "TextBlot", () => $fcc7126f4809333a$export$10ac0c5716409de6);
var $fcc7126f4809333a$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($fcc7126f4809333a$export$775b6bb06e53a214 || {});
class $fcc7126f4809333a$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $fcc7126f4809333a$export$775b6bb06e53a214.TYPE & $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL | attributeBit : $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $fcc7126f4809333a$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $fcc7126f4809333a$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $fcc7126f4809333a$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $fcc7126f4809333a$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL & $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL & $fcc7126f4809333a$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $fcc7126f4809333a$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $fcc7126f4809333a$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $fcc7126f4809333a$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $fcc7126f4809333a$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$fcc7126f4809333a$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $fcc7126f4809333a$export$4d9facee29974f3 = $fcc7126f4809333a$var$_Registry;
function $fcc7126f4809333a$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $fcc7126f4809333a$var$ClassAttributor extends $fcc7126f4809333a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $fcc7126f4809333a$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($fcc7126f4809333a$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $fcc7126f4809333a$export$651d45509677cf07 = $fcc7126f4809333a$var$ClassAttributor;
function $fcc7126f4809333a$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $fcc7126f4809333a$var$StyleAttributor extends $fcc7126f4809333a$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$fcc7126f4809333a$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$fcc7126f4809333a$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$fcc7126f4809333a$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $fcc7126f4809333a$export$7c8099bbfe87b94d = $fcc7126f4809333a$var$StyleAttributor;
class $fcc7126f4809333a$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $fcc7126f4809333a$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $fcc7126f4809333a$export$217610c4183502d0.keys(this.domNode), classes = $fcc7126f4809333a$export$651d45509677cf07.keys(this.domNode), styles = $fcc7126f4809333a$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $fcc7126f4809333a$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $fcc7126f4809333a$export$68ad86ab95e8de42 = $fcc7126f4809333a$var$AttributorStore, $fcc7126f4809333a$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $fcc7126f4809333a$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $fcc7126f4809333a$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $fcc7126f4809333a$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $fcc7126f4809333a$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$fcc7126f4809333a$var$_ShadowBlot.blotName = "abstract";
let $fcc7126f4809333a$var$ShadowBlot = $fcc7126f4809333a$var$_ShadowBlot;
const $fcc7126f4809333a$var$_LeafBlot = class _LeafBlot extends $fcc7126f4809333a$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$fcc7126f4809333a$var$_LeafBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.INLINE_BLOT;
let $fcc7126f4809333a$var$LeafBlot = $fcc7126f4809333a$var$_LeafBlot;
const $fcc7126f4809333a$export$7420b9c542181544 = $fcc7126f4809333a$var$LeafBlot;
class $fcc7126f4809333a$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $fcc7126f4809333a$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($fcc7126f4809333a$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $fcc7126f4809333a$var$_ParentBlot = class _ParentBlot extends $fcc7126f4809333a$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $fcc7126f4809333a$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $fcc7126f4809333a$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $fcc7126f4809333a$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $fcc7126f4809333a$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$fcc7126f4809333a$var$_ParentBlot.uiClass = "";
let $fcc7126f4809333a$var$ParentBlot = $fcc7126f4809333a$var$_ParentBlot;
const $fcc7126f4809333a$export$e43113f0aad76fe = $fcc7126f4809333a$var$ParentBlot;
function $fcc7126f4809333a$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $fcc7126f4809333a$var$_InlineBlot = class _InlineBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $fcc7126f4809333a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $fcc7126f4809333a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $fcc7126f4809333a$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$fcc7126f4809333a$var$_InlineBlot.allowedChildren = [
    $fcc7126f4809333a$var$_InlineBlot,
    $fcc7126f4809333a$export$7420b9c542181544
], $fcc7126f4809333a$var$_InlineBlot.blotName = "inline", $fcc7126f4809333a$var$_InlineBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.INLINE_BLOT, $fcc7126f4809333a$var$_InlineBlot.tagName = "SPAN";
let $fcc7126f4809333a$var$InlineBlot = $fcc7126f4809333a$var$_InlineBlot;
const $fcc7126f4809333a$export$f67a34bc25a7a861 = $fcc7126f4809333a$var$InlineBlot, $fcc7126f4809333a$var$_BlockBlot = class _BlockBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $fcc7126f4809333a$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $fcc7126f4809333a$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $fcc7126f4809333a$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$fcc7126f4809333a$var$_BlockBlot.blotName = "block", $fcc7126f4809333a$var$_BlockBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT, $fcc7126f4809333a$var$_BlockBlot.tagName = "P", $fcc7126f4809333a$var$_BlockBlot.allowedChildren = [
    $fcc7126f4809333a$export$f67a34bc25a7a861,
    $fcc7126f4809333a$var$_BlockBlot,
    $fcc7126f4809333a$export$7420b9c542181544
];
let $fcc7126f4809333a$var$BlockBlot = $fcc7126f4809333a$var$_BlockBlot;
const $fcc7126f4809333a$export$4f7f03641f7bfc8c = $fcc7126f4809333a$var$BlockBlot, $fcc7126f4809333a$var$_ContainerBlot = class _ContainerBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$fcc7126f4809333a$var$_ContainerBlot.blotName = "container", $fcc7126f4809333a$var$_ContainerBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT;
let $fcc7126f4809333a$var$ContainerBlot = $fcc7126f4809333a$var$_ContainerBlot;
const $fcc7126f4809333a$export$c898d510319704c0 = $fcc7126f4809333a$var$ContainerBlot;
class $fcc7126f4809333a$var$EmbedBlot extends $fcc7126f4809333a$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $fcc7126f4809333a$export$297a1fa96f55f00f = $fcc7126f4809333a$var$EmbedBlot, $fcc7126f4809333a$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $fcc7126f4809333a$var$MAX_OPTIMIZE_ITERATIONS = 100, $fcc7126f4809333a$var$_ScrollBlot = class _ScrollBlot extends $fcc7126f4809333a$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $fcc7126f4809333a$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $fcc7126f4809333a$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $fcc7126f4809333a$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $fcc7126f4809333a$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $fcc7126f4809333a$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$fcc7126f4809333a$var$_ScrollBlot.blotName = "scroll", $fcc7126f4809333a$var$_ScrollBlot.defaultChild = $fcc7126f4809333a$export$4f7f03641f7bfc8c, $fcc7126f4809333a$var$_ScrollBlot.allowedChildren = [
    $fcc7126f4809333a$export$4f7f03641f7bfc8c,
    $fcc7126f4809333a$export$c898d510319704c0
], $fcc7126f4809333a$var$_ScrollBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.BLOCK_BLOT, $fcc7126f4809333a$var$_ScrollBlot.tagName = "DIV";
let $fcc7126f4809333a$var$ScrollBlot = $fcc7126f4809333a$var$_ScrollBlot;
const $fcc7126f4809333a$export$7175329dad7a46f1 = $fcc7126f4809333a$var$ScrollBlot, $fcc7126f4809333a$var$_TextBlot = class _TextBlot extends $fcc7126f4809333a$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$fcc7126f4809333a$var$_TextBlot.blotName = "text", $fcc7126f4809333a$var$_TextBlot.scope = $fcc7126f4809333a$export$775b6bb06e53a214.INLINE_BLOT;
let $fcc7126f4809333a$var$TextBlot = $fcc7126f4809333a$var$_TextBlot;
const $fcc7126f4809333a$export$10ac0c5716409de6 = $fcc7126f4809333a$var$TextBlot;

});

parcelRegister("kEXGb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AttributeMap = module.exports.OpIterator = module.exports.Op = void 0;

var $kp0J9 = parcelRequire("kp0J9");

var $l8f2B = parcelRequire("l8f2B");

var $3IYP4 = parcelRequire("3IYP4");

var $dGgcE = parcelRequire("dGgcE");
module.exports.AttributeMap = $dGgcE.default;

var $03VRP = parcelRequire("03VRP");
module.exports.Op = $03VRP.default;

var $bmFu7 = parcelRequire("bmFu7");
module.exports.OpIterator = $bmFu7.default;
const $f0a5d622b7cbf8c6$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $f0a5d622b7cbf8c6$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $f0a5d622b7cbf8c6$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $l8f2B(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($3IYP4(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $03VRP.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $03VRP.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $bmFu7.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $03VRP.default.length(nextOp);
        }
        return new $f0a5d622b7cbf8c6$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $bmFu7.default(this.ops);
        const otherIter = new $bmFu7.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $f0a5d622b7cbf8c6$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $f0a5d622b7cbf8c6$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $f0a5d622b7cbf8c6$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $dGgcE.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $3IYP4(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $f0a5d622b7cbf8c6$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $f0a5d622b7cbf8c6$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $f0a5d622b7cbf8c6$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $f0a5d622b7cbf8c6$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $f0a5d622b7cbf8c6$var$Delta();
        const diffResult = $kp0J9(strings[0], strings[1], cursor, true);
        const thisIter = new $bmFu7.default(this.ops);
        const otherIter = new $bmFu7.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $kp0J9.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $kp0J9.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $kp0J9.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($3IYP4(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $dGgcE.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $bmFu7.default(this.ops);
        let line = new $f0a5d622b7cbf8c6$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $03VRP.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $f0a5d622b7cbf8c6$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $f0a5d622b7cbf8c6$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($03VRP.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($03VRP.default.length(baseOp), $dGgcE.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $bmFu7.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $f0a5d622b7cbf8c6$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $f0a5d622b7cbf8c6$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $dGgcE.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $bmFu7.default(this.ops);
        const otherIter = new $bmFu7.default(other.ops);
        const delta = new $f0a5d622b7cbf8c6$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($03VRP.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $f0a5d622b7cbf8c6$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $dGgcE.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $bmFu7.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$f0a5d622b7cbf8c6$var$Delta.Op = $03VRP.default;
$f0a5d622b7cbf8c6$var$Delta.OpIterator = $bmFu7.default;
$f0a5d622b7cbf8c6$var$Delta.AttributeMap = $dGgcE.default;
$f0a5d622b7cbf8c6$var$Delta.handlers = {};
module.exports.default = $f0a5d622b7cbf8c6$var$Delta;
module.exports = $f0a5d622b7cbf8c6$var$Delta;
module.exports.default = $f0a5d622b7cbf8c6$var$Delta;

});
parcelRegister("kp0J9", function(module, exports) {
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $eda6b4d975180353$var$DIFF_DELETE = -1;
var $eda6b4d975180353$var$DIFF_INSERT = 1;
var $eda6b4d975180353$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $eda6b4d975180353$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $eda6b4d975180353$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $eda6b4d975180353$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $eda6b4d975180353$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $eda6b4d975180353$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $eda6b4d975180353$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $eda6b4d975180353$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $eda6b4d975180353$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $eda6b4d975180353$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $eda6b4d975180353$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $eda6b4d975180353$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $eda6b4d975180353$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $eda6b4d975180353$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            text1
        ],
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $eda6b4d975180353$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $eda6b4d975180353$var$diff_main(text1_a, text2_a);
        var diffs_b = $eda6b4d975180353$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $eda6b4d975180353$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $eda6b4d975180353$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $eda6b4d975180353$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $eda6b4d975180353$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $eda6b4d975180353$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            text1
        ],
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $eda6b4d975180353$var$diff_main(text1a, text2a);
    var diffsb = $eda6b4d975180353$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $eda6b4d975180353$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($eda6b4d975180353$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $eda6b4d975180353$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $eda6b4d975180353$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($eda6b4d975180353$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $eda6b4d975180353$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $eda6b4d975180353$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $eda6b4d975180353$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $eda6b4d975180353$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $eda6b4d975180353$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $eda6b4d975180353$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $eda6b4d975180353$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $eda6b4d975180353$var$diff_cleanupMerge(diffs);
    $eda6b4d975180353$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $eda6b4d975180353$var$DIFF_DELETE && diffs[pointer][0] == $eda6b4d975180353$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $eda6b4d975180353$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $eda6b4d975180353$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $eda6b4d975180353$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $eda6b4d975180353$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $eda6b4d975180353$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $eda6b4d975180353$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $eda6b4d975180353$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $eda6b4d975180353$var$whitespaceRegex_ = /\s/;
var $eda6b4d975180353$var$linebreakRegex_ = /[\r\n]/;
var $eda6b4d975180353$var$blanklineEndRegex_ = /\n\r?\n$/;
var $eda6b4d975180353$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $eda6b4d975180353$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($eda6b4d975180353$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($eda6b4d975180353$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($eda6b4d975180353$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($eda6b4d975180353$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($eda6b4d975180353$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($eda6b4d975180353$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($eda6b4d975180353$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($eda6b4d975180353$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $eda6b4d975180353$var$DIFF_EQUAL && diffs[pointer + 1][0] == $eda6b4d975180353$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $eda6b4d975180353$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $eda6b4d975180353$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $eda6b4d975180353$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $eda6b4d975180353$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $eda6b4d975180353$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $eda6b4d975180353$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $eda6b4d975180353$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $eda6b4d975180353$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $eda6b4d975180353$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($eda6b4d975180353$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $eda6b4d975180353$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $eda6b4d975180353$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $eda6b4d975180353$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $eda6b4d975180353$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $eda6b4d975180353$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $eda6b4d975180353$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $eda6b4d975180353$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $eda6b4d975180353$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $eda6b4d975180353$var$DIFF_EQUAL && diffs[pointer + 1][0] === $eda6b4d975180353$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $eda6b4d975180353$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $eda6b4d975180353$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $eda6b4d975180353$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $eda6b4d975180353$var$starts_with_pair_end(str) {
    return $eda6b4d975180353$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $eda6b4d975180353$var$ends_with_pair_start(str) {
    return $eda6b4d975180353$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $eda6b4d975180353$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $eda6b4d975180353$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($eda6b4d975180353$var$ends_with_pair_start(before) || $eda6b4d975180353$var$starts_with_pair_end(after)) return null;
    return $eda6b4d975180353$var$remove_empty_tuples([
        [
            $eda6b4d975180353$var$DIFF_EQUAL,
            before
        ],
        [
            $eda6b4d975180353$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $eda6b4d975180353$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $eda6b4d975180353$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $eda6b4d975180353$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $eda6b4d975180353$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $eda6b4d975180353$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $eda6b4d975180353$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $eda6b4d975180353$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $eda6b4d975180353$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$eda6b4d975180353$var$diff.INSERT = $eda6b4d975180353$var$DIFF_INSERT;
$eda6b4d975180353$var$diff.DELETE = $eda6b4d975180353$var$DIFF_DELETE;
$eda6b4d975180353$var$diff.EQUAL = $eda6b4d975180353$var$DIFF_EQUAL;
module.exports = $eda6b4d975180353$var$diff;

});

parcelRegister("l8f2B", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("3IYP4", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("dGgcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l8f2B = parcelRequire("l8f2B");

var $3IYP4 = parcelRequire("3IYP4");
var $9f5bc434b2268299$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $l8f2B(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$3IYP4(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($9f5bc434b2268299$var$AttributeMap || ($9f5bc434b2268299$var$AttributeMap = {}));
module.exports.default = $9f5bc434b2268299$var$AttributeMap;

});

parcelRegister("03VRP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $00bd2b2687979ad4$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($00bd2b2687979ad4$var$Op || ($00bd2b2687979ad4$var$Op = {}));
module.exports.default = $00bd2b2687979ad4$var$Op;

});

parcelRegister("bmFu7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $03VRP = parcelRequire("03VRP");
class $8461edc910d6a1b9$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $03VRP.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $03VRP.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
module.exports.default = $8461edc910d6a1b9$var$Iterator;

});


parcelRegister("bLz0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $890f3eb14eb0e0b8$export$2e2bcd8739ae039);

var $kaYY4 = parcelRequire("kaYY4");
var $d7fWe = parcelRequire("d7fWe");
var $4exCq = parcelRequire("4exCq");

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $luQs7 = parcelRequire("luQs7");

var $bxVMH = parcelRequire("bxVMH");

var $3EdO3 = parcelRequire("3EdO3");
const $890f3eb14eb0e0b8$var$ASCII = /^[ -~]*$/;
class $890f3eb14eb0e0b8$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $890f3eb14eb0e0b8$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
        const normalizedOps = $890f3eb14eb0e0b8$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $kEXGb.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $fp1Tt.BlockEmbed), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $4exCq.default)({}, (0, $fp1Tt.bubbleFormats)(line));
                    if (line instanceof (0, $fp1Tt.default)) {
                        const [leaf] = line.descendant((0, $lHwOS.LeafBlot), offset);
                        if (leaf) formats = (0, $4exCq.default)(formats, (0, $fp1Tt.bubbleFormats)(leaf));
                    }
                    attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $lHwOS.Scope).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $fp1Tt.BlockEmbed), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $lHwOS.LeafBlot), index - 1);
                        if (leaf instanceof (0, $bxVMH.default)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $lHwOS.EmbedBlot) && leaf.statics.scope === (0, $lHwOS.Scope).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $lHwOS.LeafBlot), index);
                        if (leaf) {
                            const formats = (0, $4exCq.default)({}, (0, $fp1Tt.bubbleFormats)(leaf));
                            attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $kEXGb.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).retain(length, (0, $kaYY4.default)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).retain(length, (0, $kaYY4.default)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $fp1Tt.default)) lines.push(blot);
            else if (blot instanceof (0, $lHwOS.LeafBlot)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $lHwOS.LeafBlot), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $fp1Tt.bubbleFormats)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $890f3eb14eb0e0b8$var$combineFormats((0, $fp1Tt.bubbleFormats)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $890f3eb14eb0e0b8$var$convertHTML(line, lineOffset, length, true);
            return $890f3eb14eb0e0b8$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $890f3eb14eb0e0b8$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert(text, (0, $kaYY4.default)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $fp1Tt.default).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $bmwCM.default);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($890f3eb14eb0e0b8$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $fp1Tt.bubbleFormats)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $luQs7.default).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $890f3eb14eb0e0b8$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $890f3eb14eb0e0b8$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $d7fWe.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $890f3eb14eb0e0b8$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $890f3eb14eb0e0b8$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$890f3eb14eb0e0b8$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $890f3eb14eb0e0b8$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$890f3eb14eb0e0b8$var$convertHTML(child, offset, length)}${$890f3eb14eb0e0b8$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$890f3eb14eb0e0b8$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$890f3eb14eb0e0b8$var$convertHTML(child, offset, length)}${$890f3eb14eb0e0b8$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $890f3eb14eb0e0b8$var$getListType(types.pop());
    return `</li></${endTag}>${$890f3eb14eb0e0b8$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $890f3eb14eb0e0b8$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $bxVMH.default)) {
        const escapedText = (0, $bxVMH.escapeText)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $lHwOS.ParentBlot)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $890f3eb14eb0e0b8$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($890f3eb14eb0e0b8$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $890f3eb14eb0e0b8$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $890f3eb14eb0e0b8$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $890f3eb14eb0e0b8$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
}
function $890f3eb14eb0e0b8$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $3EdO3.Range)(index + amount, length);
}
function $890f3eb14eb0e0b8$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $890f3eb14eb0e0b8$export$2e2bcd8739ae039 = $890f3eb14eb0e0b8$var$Editor;

});
parcelRegister("kaYY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0408c135f33041$export$2e2bcd8739ae039);

var $IAViM = parcelRequire("IAViM");
/** Used to compose bitmasks for cloning. */ var $eb0408c135f33041$var$CLONE_DEEP_FLAG = 1, $eb0408c135f33041$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $eb0408c135f33041$var$cloneDeep(value) {
    return (0, $IAViM.default)(value, $eb0408c135f33041$var$CLONE_DEEP_FLAG | $eb0408c135f33041$var$CLONE_SYMBOLS_FLAG);
}
var $eb0408c135f33041$export$2e2bcd8739ae039 = $eb0408c135f33041$var$cloneDeep;

});
parcelRegister("IAViM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0860c05bc80ebbfa$export$2e2bcd8739ae039);

var $ch4ws = parcelRequire("ch4ws");

var $5rLOb = parcelRequire("5rLOb");

var $kYkm0 = parcelRequire("kYkm0");

var $2oR8L = parcelRequire("2oR8L");

var $fnLNg = parcelRequire("fnLNg");

var $imxSd = parcelRequire("imxSd");

var $6x0q0 = parcelRequire("6x0q0");

var $5vHz2 = parcelRequire("5vHz2");

var $9pdV7 = parcelRequire("9pdV7");

var $bZZOu = parcelRequire("bZZOu");

var $8sQaT = parcelRequire("8sQaT");

var $81bAo = parcelRequire("81bAo");

var $dseQ6 = parcelRequire("dseQ6");

var $1Nluj = parcelRequire("1Nluj");

var $hMPMN = parcelRequire("hMPMN");

var $hXn90 = parcelRequire("hXn90");

var $hiJJV = parcelRequire("hiJJV");

var $4frQp = parcelRequire("4frQp");

var $kXXxV = parcelRequire("kXXxV");

var $gFm9h = parcelRequire("gFm9h");

var $8tp0Q = parcelRequire("8tp0Q");

var $fIbiK = parcelRequire("fIbiK");
/** Used to compose bitmasks for cloning. */ var $0860c05bc80ebbfa$var$CLONE_DEEP_FLAG = 1, $0860c05bc80ebbfa$var$CLONE_FLAT_FLAG = 2, $0860c05bc80ebbfa$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $0860c05bc80ebbfa$var$argsTag = '[object Arguments]', $0860c05bc80ebbfa$var$arrayTag = '[object Array]', $0860c05bc80ebbfa$var$boolTag = '[object Boolean]', $0860c05bc80ebbfa$var$dateTag = '[object Date]', $0860c05bc80ebbfa$var$errorTag = '[object Error]', $0860c05bc80ebbfa$var$funcTag = '[object Function]', $0860c05bc80ebbfa$var$genTag = '[object GeneratorFunction]', $0860c05bc80ebbfa$var$mapTag = '[object Map]', $0860c05bc80ebbfa$var$numberTag = '[object Number]', $0860c05bc80ebbfa$var$objectTag = '[object Object]', $0860c05bc80ebbfa$var$regexpTag = '[object RegExp]', $0860c05bc80ebbfa$var$setTag = '[object Set]', $0860c05bc80ebbfa$var$stringTag = '[object String]', $0860c05bc80ebbfa$var$symbolTag = '[object Symbol]', $0860c05bc80ebbfa$var$weakMapTag = '[object WeakMap]';
var $0860c05bc80ebbfa$var$arrayBufferTag = '[object ArrayBuffer]', $0860c05bc80ebbfa$var$dataViewTag = '[object DataView]', $0860c05bc80ebbfa$var$float32Tag = '[object Float32Array]', $0860c05bc80ebbfa$var$float64Tag = '[object Float64Array]', $0860c05bc80ebbfa$var$int8Tag = '[object Int8Array]', $0860c05bc80ebbfa$var$int16Tag = '[object Int16Array]', $0860c05bc80ebbfa$var$int32Tag = '[object Int32Array]', $0860c05bc80ebbfa$var$uint8Tag = '[object Uint8Array]', $0860c05bc80ebbfa$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0860c05bc80ebbfa$var$uint16Tag = '[object Uint16Array]', $0860c05bc80ebbfa$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $0860c05bc80ebbfa$var$cloneableTags = {};
$0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$argsTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$arrayTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$arrayBufferTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$dataViewTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$boolTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$dateTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$float32Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$float64Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$int8Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$int16Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$int32Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$mapTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$numberTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$objectTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$regexpTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$setTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$stringTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$symbolTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint8Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint8ClampedTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint16Tag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$uint32Tag] = true;
$0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$errorTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$funcTag] = $0860c05bc80ebbfa$var$cloneableTags[$0860c05bc80ebbfa$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $0860c05bc80ebbfa$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $0860c05bc80ebbfa$var$CLONE_DEEP_FLAG, isFlat = bitmask & $0860c05bc80ebbfa$var$CLONE_FLAT_FLAG, isFull = bitmask & $0860c05bc80ebbfa$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $kXXxV.default)(value)) return value;
    var isArr = (0, $hXn90.default)(value);
    if (isArr) {
        result = (0, $dseQ6.default)(value);
        if (!isDeep) return (0, $6x0q0.default)(value, result);
    } else {
        var tag = (0, $81bAo.default)(value), isFunc = tag == $0860c05bc80ebbfa$var$funcTag || tag == $0860c05bc80ebbfa$var$genTag;
        if ((0, $hiJJV.default)(value)) return (0, $imxSd.default)(value, isDeep);
        if (tag == $0860c05bc80ebbfa$var$objectTag || tag == $0860c05bc80ebbfa$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $hMPMN.default)(value);
            if (!isDeep) return isFlat ? (0, $9pdV7.default)(value, (0, $fnLNg.default)(result, value)) : (0, $5vHz2.default)(value, (0, $2oR8L.default)(result, value));
        } else {
            if (!$0860c05bc80ebbfa$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $1Nluj.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $ch4ws.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $gFm9h.default)(value)) value.forEach(function(subValue) {
        result.add($0860c05bc80ebbfa$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $4frQp.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $0860c05bc80ebbfa$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $8sQaT.default) : (0, $bZZOu.default) : isFlat ? (0, $fIbiK.default) : (0, $8tp0Q.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $5rLOb.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $kYkm0.default)(result, key, $0860c05bc80ebbfa$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $0860c05bc80ebbfa$export$2e2bcd8739ae039 = $0860c05bc80ebbfa$var$baseClone;

});
parcelRegister("5rLOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f748f2213654a26$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $3f748f2213654a26$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $3f748f2213654a26$export$2e2bcd8739ae039 = $3f748f2213654a26$var$arrayEach;

});

parcelRegister("2oR8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf70b3936fb696c$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $8tp0Q = parcelRequire("8tp0Q");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $1bf70b3936fb696c$var$baseAssign(object, source) {
    return object && (0, $8Up13.default)(source, (0, $8tp0Q.default)(source), object);
}
var $1bf70b3936fb696c$export$2e2bcd8739ae039 = $1bf70b3936fb696c$var$baseAssign;

});
parcelRegister("8tp0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $62b46f28be927459$export$2e2bcd8739ae039);

var $fuUH8 = parcelRequire("fuUH8");

var $703j7 = parcelRequire("703j7");

var $8pHBa = parcelRequire("8pHBa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $62b46f28be927459$var$keys(object) {
    return (0, $8pHBa.default)(object) ? (0, $fuUH8.default)(object) : (0, $703j7.default)(object);
}
var $62b46f28be927459$export$2e2bcd8739ae039 = $62b46f28be927459$var$keys;

});
parcelRegister("703j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $518b193f31e88dad$export$2e2bcd8739ae039);

var $7H3cd = parcelRequire("7H3cd");

var $gBGBx = parcelRequire("gBGBx");
/** Used for built-in method references. */ var $518b193f31e88dad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $518b193f31e88dad$var$hasOwnProperty = $518b193f31e88dad$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $518b193f31e88dad$var$baseKeys(object) {
    if (!(0, $7H3cd.default)(object)) return (0, $gBGBx.default)(object);
    var result = [];
    for(var key in Object(object))if ($518b193f31e88dad$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $518b193f31e88dad$export$2e2bcd8739ae039 = $518b193f31e88dad$var$baseKeys;

});
parcelRegister("gBGBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c171266a6ece1d65$export$2e2bcd8739ae039);

var $3knOV = parcelRequire("3knOV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c171266a6ece1d65$var$nativeKeys = (0, $3knOV.default)(Object.keys, Object);
var $c171266a6ece1d65$export$2e2bcd8739ae039 = $c171266a6ece1d65$var$nativeKeys;

});




parcelRegister("fnLNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b32e13d40e8591ac$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $fIbiK = parcelRequire("fIbiK");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b32e13d40e8591ac$var$baseAssignIn(object, source) {
    return object && (0, $8Up13.default)(source, (0, $fIbiK.default)(source), object);
}
var $b32e13d40e8591ac$export$2e2bcd8739ae039 = $b32e13d40e8591ac$var$baseAssignIn;

});

parcelRegister("5vHz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4031a3ea56a713cc$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $fAy44 = parcelRequire("fAy44");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $4031a3ea56a713cc$var$copySymbols(source, object) {
    return (0, $8Up13.default)(source, (0, $fAy44.default)(source), object);
}
var $4031a3ea56a713cc$export$2e2bcd8739ae039 = $4031a3ea56a713cc$var$copySymbols;

});
parcelRegister("fAy44", function(module, exports) {

$parcel$export(module.exports, "default", () => $b594a45b62448ad3$export$2e2bcd8739ae039);

var $2V7We = parcelRequire("2V7We");

var $72SgP = parcelRequire("72SgP");
/** Used for built-in method references. */ var $b594a45b62448ad3$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b594a45b62448ad3$var$propertyIsEnumerable = $b594a45b62448ad3$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b594a45b62448ad3$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b594a45b62448ad3$var$getSymbols = !$b594a45b62448ad3$var$nativeGetSymbols ? (0, $72SgP.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $2V7We.default)($b594a45b62448ad3$var$nativeGetSymbols(object), function(symbol) {
        return $b594a45b62448ad3$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $b594a45b62448ad3$export$2e2bcd8739ae039 = $b594a45b62448ad3$var$getSymbols;

});
parcelRegister("2V7We", function(module, exports) {

$parcel$export(module.exports, "default", () => $2207100852ffb107$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2207100852ffb107$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $2207100852ffb107$export$2e2bcd8739ae039 = $2207100852ffb107$var$arrayFilter;

});

parcelRegister("72SgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5212d14793e4f03b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $5212d14793e4f03b$var$stubArray() {
    return [];
}
var $5212d14793e4f03b$export$2e2bcd8739ae039 = $5212d14793e4f03b$var$stubArray;

});



parcelRegister("9pdV7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d913f1bf92079a5$export$2e2bcd8739ae039);

var $8Up13 = parcelRequire("8Up13");

var $eywhD = parcelRequire("eywhD");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $6d913f1bf92079a5$var$copySymbolsIn(source, object) {
    return (0, $8Up13.default)(source, (0, $eywhD.default)(source), object);
}
var $6d913f1bf92079a5$export$2e2bcd8739ae039 = $6d913f1bf92079a5$var$copySymbolsIn;

});
parcelRegister("eywhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98d4874d94f7a2a$export$2e2bcd8739ae039);

var $2aSL7 = parcelRequire("2aSL7");

var $lPOv3 = parcelRequire("lPOv3");

var $fAy44 = parcelRequire("fAy44");

var $72SgP = parcelRequire("72SgP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a98d4874d94f7a2a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a98d4874d94f7a2a$var$getSymbolsIn = !$a98d4874d94f7a2a$var$nativeGetSymbols ? (0, $72SgP.default) : function(object) {
    var result = [];
    while(object){
        (0, $2aSL7.default)(result, (0, $fAy44.default)(object));
        object = (0, $lPOv3.default)(object);
    }
    return result;
};
var $a98d4874d94f7a2a$export$2e2bcd8739ae039 = $a98d4874d94f7a2a$var$getSymbolsIn;

});
parcelRegister("2aSL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1956fdf36ee5f114$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $1956fdf36ee5f114$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $1956fdf36ee5f114$export$2e2bcd8739ae039 = $1956fdf36ee5f114$var$arrayPush;

});



parcelRegister("bZZOu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc5570c7156bb88$export$2e2bcd8739ae039);

var $6vvEy = parcelRequire("6vvEy");

var $fAy44 = parcelRequire("fAy44");

var $8tp0Q = parcelRequire("8tp0Q");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8bc5570c7156bb88$var$getAllKeys(object) {
    return (0, $6vvEy.default)(object, (0, $8tp0Q.default), (0, $fAy44.default));
}
var $8bc5570c7156bb88$export$2e2bcd8739ae039 = $8bc5570c7156bb88$var$getAllKeys;

});
parcelRegister("6vvEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bce30f8fa9644a6$export$2e2bcd8739ae039);

var $2aSL7 = parcelRequire("2aSL7");

var $hXn90 = parcelRequire("hXn90");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4bce30f8fa9644a6$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hXn90.default)(object) ? result : (0, $2aSL7.default)(result, symbolsFunc(object));
}
var $4bce30f8fa9644a6$export$2e2bcd8739ae039 = $4bce30f8fa9644a6$var$baseGetAllKeys;

});


parcelRegister("8sQaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6299690b9db96e04$export$2e2bcd8739ae039);

var $6vvEy = parcelRequire("6vvEy");

var $eywhD = parcelRequire("eywhD");

var $fIbiK = parcelRequire("fIbiK");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6299690b9db96e04$var$getAllKeysIn(object) {
    return (0, $6vvEy.default)(object, (0, $fIbiK.default), (0, $eywhD.default));
}
var $6299690b9db96e04$export$2e2bcd8739ae039 = $6299690b9db96e04$var$getAllKeysIn;

});

parcelRegister("81bAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d6767722ca7e051$export$2e2bcd8739ae039);

var $hEfjz = parcelRequire("hEfjz");

var $fHOWn = parcelRequire("fHOWn");

var $2w9T8 = parcelRequire("2w9T8");

var $ilyUh = parcelRequire("ilyUh");

var $fvdpy = parcelRequire("fvdpy");

var $f4sy6 = parcelRequire("f4sy6");

var $gu9fH = parcelRequire("gu9fH");
/** `Object#toString` result references. */ var $5d6767722ca7e051$var$mapTag = '[object Map]', $5d6767722ca7e051$var$objectTag = '[object Object]', $5d6767722ca7e051$var$promiseTag = '[object Promise]', $5d6767722ca7e051$var$setTag = '[object Set]', $5d6767722ca7e051$var$weakMapTag = '[object WeakMap]';
var $5d6767722ca7e051$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $5d6767722ca7e051$var$dataViewCtorString = (0, $gu9fH.default)((0, $hEfjz.default)), $5d6767722ca7e051$var$mapCtorString = (0, $gu9fH.default)((0, $fHOWn.default)), $5d6767722ca7e051$var$promiseCtorString = (0, $gu9fH.default)((0, $2w9T8.default)), $5d6767722ca7e051$var$setCtorString = (0, $gu9fH.default)((0, $ilyUh.default)), $5d6767722ca7e051$var$weakMapCtorString = (0, $gu9fH.default)((0, $fvdpy.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5d6767722ca7e051$var$getTag = (0, $f4sy6.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $hEfjz.default) && $5d6767722ca7e051$var$getTag(new (0, $hEfjz.default)(new ArrayBuffer(1))) != $5d6767722ca7e051$var$dataViewTag || (0, $fHOWn.default) && $5d6767722ca7e051$var$getTag(new (0, $fHOWn.default)) != $5d6767722ca7e051$var$mapTag || (0, $2w9T8.default) && $5d6767722ca7e051$var$getTag((0, $2w9T8.default).resolve()) != $5d6767722ca7e051$var$promiseTag || (0, $ilyUh.default) && $5d6767722ca7e051$var$getTag(new (0, $ilyUh.default)) != $5d6767722ca7e051$var$setTag || (0, $fvdpy.default) && $5d6767722ca7e051$var$getTag(new (0, $fvdpy.default)) != $5d6767722ca7e051$var$weakMapTag) $5d6767722ca7e051$var$getTag = function(value) {
    var result = (0, $f4sy6.default)(value), Ctor = result == $5d6767722ca7e051$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $gu9fH.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $5d6767722ca7e051$var$dataViewCtorString:
            return $5d6767722ca7e051$var$dataViewTag;
        case $5d6767722ca7e051$var$mapCtorString:
            return $5d6767722ca7e051$var$mapTag;
        case $5d6767722ca7e051$var$promiseCtorString:
            return $5d6767722ca7e051$var$promiseTag;
        case $5d6767722ca7e051$var$setCtorString:
            return $5d6767722ca7e051$var$setTag;
        case $5d6767722ca7e051$var$weakMapCtorString:
            return $5d6767722ca7e051$var$weakMapTag;
    }
    return result;
};
var $5d6767722ca7e051$export$2e2bcd8739ae039 = $5d6767722ca7e051$var$getTag;

});
parcelRegister("hEfjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd920d411d2eb52f$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $cd920d411d2eb52f$var$DataView = (0, $8dB7s.default)((0, $2ZUhy.default), 'DataView');
var $cd920d411d2eb52f$export$2e2bcd8739ae039 = $cd920d411d2eb52f$var$DataView;

});

parcelRegister("2w9T8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d563d83fcff7b61$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $1d563d83fcff7b61$var$Promise = (0, $8dB7s.default)((0, $2ZUhy.default), 'Promise');
var $1d563d83fcff7b61$export$2e2bcd8739ae039 = $1d563d83fcff7b61$var$Promise;

});

parcelRegister("ilyUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5b543ee395fc2f5$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $d5b543ee395fc2f5$var$Set = (0, $8dB7s.default)((0, $2ZUhy.default), 'Set');
var $d5b543ee395fc2f5$export$2e2bcd8739ae039 = $d5b543ee395fc2f5$var$Set;

});

parcelRegister("fvdpy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4942771dda5629d$export$2e2bcd8739ae039);

var $8dB7s = parcelRequire("8dB7s");

var $2ZUhy = parcelRequire("2ZUhy");
/* Built-in method references that are verified to be native. */ var $b4942771dda5629d$var$WeakMap = (0, $8dB7s.default)((0, $2ZUhy.default), 'WeakMap');
var $b4942771dda5629d$export$2e2bcd8739ae039 = $b4942771dda5629d$var$WeakMap;

});


parcelRegister("dseQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb966a6de1f6e55$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $9cb966a6de1f6e55$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9cb966a6de1f6e55$var$hasOwnProperty = $9cb966a6de1f6e55$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $9cb966a6de1f6e55$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $9cb966a6de1f6e55$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $9cb966a6de1f6e55$export$2e2bcd8739ae039 = $9cb966a6de1f6e55$var$initCloneArray;

});

parcelRegister("1Nluj", function(module, exports) {

$parcel$export(module.exports, "default", () => $14eb0915c8354295$export$2e2bcd8739ae039);

var $aal8n = parcelRequire("aal8n");

var $iwlNg = parcelRequire("iwlNg");

var $6nUzy = parcelRequire("6nUzy");

var $dsYzv = parcelRequire("dsYzv");

var $70ZJW = parcelRequire("70ZJW");
/** `Object#toString` result references. */ var $14eb0915c8354295$var$boolTag = '[object Boolean]', $14eb0915c8354295$var$dateTag = '[object Date]', $14eb0915c8354295$var$mapTag = '[object Map]', $14eb0915c8354295$var$numberTag = '[object Number]', $14eb0915c8354295$var$regexpTag = '[object RegExp]', $14eb0915c8354295$var$setTag = '[object Set]', $14eb0915c8354295$var$stringTag = '[object String]', $14eb0915c8354295$var$symbolTag = '[object Symbol]';
var $14eb0915c8354295$var$arrayBufferTag = '[object ArrayBuffer]', $14eb0915c8354295$var$dataViewTag = '[object DataView]', $14eb0915c8354295$var$float32Tag = '[object Float32Array]', $14eb0915c8354295$var$float64Tag = '[object Float64Array]', $14eb0915c8354295$var$int8Tag = '[object Int8Array]', $14eb0915c8354295$var$int16Tag = '[object Int16Array]', $14eb0915c8354295$var$int32Tag = '[object Int32Array]', $14eb0915c8354295$var$uint8Tag = '[object Uint8Array]', $14eb0915c8354295$var$uint8ClampedTag = '[object Uint8ClampedArray]', $14eb0915c8354295$var$uint16Tag = '[object Uint16Array]', $14eb0915c8354295$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $14eb0915c8354295$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $14eb0915c8354295$var$arrayBufferTag:
            return (0, $aal8n.default)(object);
        case $14eb0915c8354295$var$boolTag:
        case $14eb0915c8354295$var$dateTag:
            return new Ctor(+object);
        case $14eb0915c8354295$var$dataViewTag:
            return (0, $iwlNg.default)(object, isDeep);
        case $14eb0915c8354295$var$float32Tag:
        case $14eb0915c8354295$var$float64Tag:
        case $14eb0915c8354295$var$int8Tag:
        case $14eb0915c8354295$var$int16Tag:
        case $14eb0915c8354295$var$int32Tag:
        case $14eb0915c8354295$var$uint8Tag:
        case $14eb0915c8354295$var$uint8ClampedTag:
        case $14eb0915c8354295$var$uint16Tag:
        case $14eb0915c8354295$var$uint32Tag:
            return (0, $70ZJW.default)(object, isDeep);
        case $14eb0915c8354295$var$mapTag:
            return new Ctor;
        case $14eb0915c8354295$var$numberTag:
        case $14eb0915c8354295$var$stringTag:
            return new Ctor(object);
        case $14eb0915c8354295$var$regexpTag:
            return (0, $6nUzy.default)(object);
        case $14eb0915c8354295$var$setTag:
            return new Ctor;
        case $14eb0915c8354295$var$symbolTag:
            return (0, $dsYzv.default)(object);
    }
}
var $14eb0915c8354295$export$2e2bcd8739ae039 = $14eb0915c8354295$var$initCloneByTag;

});
parcelRegister("iwlNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7bc1ee4e27dfdcf$export$2e2bcd8739ae039);

var $aal8n = parcelRequire("aal8n");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $d7bc1ee4e27dfdcf$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $aal8n.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $d7bc1ee4e27dfdcf$export$2e2bcd8739ae039 = $d7bc1ee4e27dfdcf$var$cloneDataView;

});

parcelRegister("6nUzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a60c62793ffe472$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $4a60c62793ffe472$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $4a60c62793ffe472$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $4a60c62793ffe472$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $4a60c62793ffe472$export$2e2bcd8739ae039 = $4a60c62793ffe472$var$cloneRegExp;

});

parcelRegister("dsYzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cdce02535daccfa$export$2e2bcd8739ae039);

var $9O75z = parcelRequire("9O75z");
/** Used to convert symbols to primitives and strings. */ var $9cdce02535daccfa$var$symbolProto = (0, $9O75z.default) ? (0, $9O75z.default).prototype : undefined, $9cdce02535daccfa$var$symbolValueOf = $9cdce02535daccfa$var$symbolProto ? $9cdce02535daccfa$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $9cdce02535daccfa$var$cloneSymbol(symbol) {
    return $9cdce02535daccfa$var$symbolValueOf ? Object($9cdce02535daccfa$var$symbolValueOf.call(symbol)) : {};
}
var $9cdce02535daccfa$export$2e2bcd8739ae039 = $9cdce02535daccfa$var$cloneSymbol;

});


parcelRegister("4frQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $317e296c7c43244d$export$2e2bcd8739ae039);

var $l24B7 = parcelRequire("l24B7");

var $i0Jgc = parcelRequire("i0Jgc");

var $lAe6g = parcelRequire("lAe6g");
/* Node.js helper references. */ var $317e296c7c43244d$var$nodeIsMap = (0, $lAe6g.default) && (0, $lAe6g.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $317e296c7c43244d$var$isMap = $317e296c7c43244d$var$nodeIsMap ? (0, $i0Jgc.default)($317e296c7c43244d$var$nodeIsMap) : (0, $l24B7.default);
var $317e296c7c43244d$export$2e2bcd8739ae039 = $317e296c7c43244d$var$isMap;

});
parcelRegister("l24B7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fd59e09539f481$export$2e2bcd8739ae039);

var $81bAo = parcelRequire("81bAo");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $f4fd59e09539f481$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $f4fd59e09539f481$var$baseIsMap(value) {
    return (0, $ydcRw.default)(value) && (0, $81bAo.default)(value) == $f4fd59e09539f481$var$mapTag;
}
var $f4fd59e09539f481$export$2e2bcd8739ae039 = $f4fd59e09539f481$var$baseIsMap;

});


parcelRegister("gFm9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c221a7ee0bc88bd2$export$2e2bcd8739ae039);

var $8d0Ps = parcelRequire("8d0Ps");

var $i0Jgc = parcelRequire("i0Jgc");

var $lAe6g = parcelRequire("lAe6g");
/* Node.js helper references. */ var $c221a7ee0bc88bd2$var$nodeIsSet = (0, $lAe6g.default) && (0, $lAe6g.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $c221a7ee0bc88bd2$var$isSet = $c221a7ee0bc88bd2$var$nodeIsSet ? (0, $i0Jgc.default)($c221a7ee0bc88bd2$var$nodeIsSet) : (0, $8d0Ps.default);
var $c221a7ee0bc88bd2$export$2e2bcd8739ae039 = $c221a7ee0bc88bd2$var$isSet;

});
parcelRegister("8d0Ps", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa02e3c94def8cf$export$2e2bcd8739ae039);

var $81bAo = parcelRequire("81bAo");

var $ydcRw = parcelRequire("ydcRw");
/** `Object#toString` result references. */ var $5fa02e3c94def8cf$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $5fa02e3c94def8cf$var$baseIsSet(value) {
    return (0, $ydcRw.default)(value) && (0, $81bAo.default)(value) == $5fa02e3c94def8cf$var$setTag;
}
var $5fa02e3c94def8cf$export$2e2bcd8739ae039 = $5fa02e3c94def8cf$var$baseIsSet;

});




parcelRegister("d7fWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c84ad0f39c492c$export$2e2bcd8739ae039);

var $4Svu9 = parcelRequire("4Svu9");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $98c84ad0f39c492c$var$isEqual(value, other) {
    return (0, $4Svu9.default)(value, other);
}
var $98c84ad0f39c492c$export$2e2bcd8739ae039 = $98c84ad0f39c492c$var$isEqual;

});
parcelRegister("4Svu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $38d4a0e30de809f2$export$2e2bcd8739ae039);

var $g4toE = parcelRequire("g4toE");

var $ydcRw = parcelRequire("ydcRw");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $38d4a0e30de809f2$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $ydcRw.default)(value) && !(0, $ydcRw.default)(other)) return value !== value && other !== other;
    return (0, $g4toE.default)(value, other, bitmask, customizer, $38d4a0e30de809f2$var$baseIsEqual, stack);
}
var $38d4a0e30de809f2$export$2e2bcd8739ae039 = $38d4a0e30de809f2$var$baseIsEqual;

});
parcelRegister("g4toE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb33d29d0aeb67aa$export$2e2bcd8739ae039);

var $ch4ws = parcelRequire("ch4ws");

var $5k7WO = parcelRequire("5k7WO");

var $jMbee = parcelRequire("jMbee");

var $dxYwk = parcelRequire("dxYwk");

var $81bAo = parcelRequire("81bAo");

var $hXn90 = parcelRequire("hXn90");

var $hiJJV = parcelRequire("hiJJV");

var $ckYSa = parcelRequire("ckYSa");
/** Used to compose bitmasks for value comparisons. */ var $bb33d29d0aeb67aa$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $bb33d29d0aeb67aa$var$argsTag = '[object Arguments]', $bb33d29d0aeb67aa$var$arrayTag = '[object Array]', $bb33d29d0aeb67aa$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bb33d29d0aeb67aa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb33d29d0aeb67aa$var$hasOwnProperty = $bb33d29d0aeb67aa$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bb33d29d0aeb67aa$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $hXn90.default)(object), othIsArr = (0, $hXn90.default)(other), objTag = objIsArr ? $bb33d29d0aeb67aa$var$arrayTag : (0, $81bAo.default)(object), othTag = othIsArr ? $bb33d29d0aeb67aa$var$arrayTag : (0, $81bAo.default)(other);
    objTag = objTag == $bb33d29d0aeb67aa$var$argsTag ? $bb33d29d0aeb67aa$var$objectTag : objTag;
    othTag = othTag == $bb33d29d0aeb67aa$var$argsTag ? $bb33d29d0aeb67aa$var$objectTag : othTag;
    var objIsObj = objTag == $bb33d29d0aeb67aa$var$objectTag, othIsObj = othTag == $bb33d29d0aeb67aa$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $hiJJV.default)(object)) {
        if (!(0, $hiJJV.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $ch4ws.default));
        return objIsArr || (0, $ckYSa.default)(object) ? (0, $5k7WO.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $jMbee.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $bb33d29d0aeb67aa$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $bb33d29d0aeb67aa$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $bb33d29d0aeb67aa$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $ch4ws.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $ch4ws.default));
    return (0, $dxYwk.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $bb33d29d0aeb67aa$export$2e2bcd8739ae039 = $bb33d29d0aeb67aa$var$baseIsEqualDeep;

});
parcelRegister("5k7WO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e04fc3a5fa7ba65$export$2e2bcd8739ae039);

var $5vzqX = parcelRequire("5vzqX");

var $gFXKj = parcelRequire("gFXKj");

var $giJzR = parcelRequire("giJzR");
/** Used to compose bitmasks for value comparisons. */ var $3e04fc3a5fa7ba65$var$COMPARE_PARTIAL_FLAG = 1, $3e04fc3a5fa7ba65$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3e04fc3a5fa7ba65$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3e04fc3a5fa7ba65$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3e04fc3a5fa7ba65$var$COMPARE_UNORDERED_FLAG ? new (0, $5vzqX.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $gFXKj.default)(other, function(othValue, othIndex) {
                if (!(0, $giJzR.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $3e04fc3a5fa7ba65$export$2e2bcd8739ae039 = $3e04fc3a5fa7ba65$var$equalArrays;

});
parcelRegister("5vzqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $402b556556c042c3$export$2e2bcd8739ae039);

var $j9mMr = parcelRequire("j9mMr");

var $kIatD = parcelRequire("kIatD");

var $5LWBr = parcelRequire("5LWBr");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $402b556556c042c3$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $j9mMr.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$402b556556c042c3$var$SetCache.prototype.add = $402b556556c042c3$var$SetCache.prototype.push = (0, $kIatD.default);
$402b556556c042c3$var$SetCache.prototype.has = (0, $5LWBr.default);
var $402b556556c042c3$export$2e2bcd8739ae039 = $402b556556c042c3$var$SetCache;

});
parcelRegister("kIatD", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e421368511473f$export$2e2bcd8739ae039);
/** Used to stand-in for `undefined` hash values. */ var $03e421368511473f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $03e421368511473f$var$setCacheAdd(value) {
    this.__data__.set(value, $03e421368511473f$var$HASH_UNDEFINED);
    return this;
}
var $03e421368511473f$export$2e2bcd8739ae039 = $03e421368511473f$var$setCacheAdd;

});

parcelRegister("5LWBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $433eccd36bf486e4$export$2e2bcd8739ae039);
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $433eccd36bf486e4$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $433eccd36bf486e4$export$2e2bcd8739ae039 = $433eccd36bf486e4$var$setCacheHas;

});


parcelRegister("gFXKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23ed1fb8be6bc70$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c23ed1fb8be6bc70$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $c23ed1fb8be6bc70$export$2e2bcd8739ae039 = $c23ed1fb8be6bc70$var$arraySome;

});

parcelRegister("giJzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde1ae7fa7cc55b1$export$2e2bcd8739ae039);
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bde1ae7fa7cc55b1$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $bde1ae7fa7cc55b1$export$2e2bcd8739ae039 = $bde1ae7fa7cc55b1$var$cacheHas;

});


parcelRegister("jMbee", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65b35c84a7dc362$export$2e2bcd8739ae039);

var $9O75z = parcelRequire("9O75z");

var $7uREm = parcelRequire("7uREm");

var $78Lr5 = parcelRequire("78Lr5");

var $5k7WO = parcelRequire("5k7WO");

var $66uCe = parcelRequire("66uCe");

var $eBtAy = parcelRequire("eBtAy");
/** Used to compose bitmasks for value comparisons. */ var $e65b35c84a7dc362$var$COMPARE_PARTIAL_FLAG = 1, $e65b35c84a7dc362$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e65b35c84a7dc362$var$boolTag = '[object Boolean]', $e65b35c84a7dc362$var$dateTag = '[object Date]', $e65b35c84a7dc362$var$errorTag = '[object Error]', $e65b35c84a7dc362$var$mapTag = '[object Map]', $e65b35c84a7dc362$var$numberTag = '[object Number]', $e65b35c84a7dc362$var$regexpTag = '[object RegExp]', $e65b35c84a7dc362$var$setTag = '[object Set]', $e65b35c84a7dc362$var$stringTag = '[object String]', $e65b35c84a7dc362$var$symbolTag = '[object Symbol]';
var $e65b35c84a7dc362$var$arrayBufferTag = '[object ArrayBuffer]', $e65b35c84a7dc362$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $e65b35c84a7dc362$var$symbolProto = (0, $9O75z.default) ? (0, $9O75z.default).prototype : undefined, $e65b35c84a7dc362$var$symbolValueOf = $e65b35c84a7dc362$var$symbolProto ? $e65b35c84a7dc362$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e65b35c84a7dc362$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e65b35c84a7dc362$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e65b35c84a7dc362$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $7uREm.default)(object), new (0, $7uREm.default)(other))) return false;
            return true;
        case $e65b35c84a7dc362$var$boolTag:
        case $e65b35c84a7dc362$var$dateTag:
        case $e65b35c84a7dc362$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $78Lr5.default)(+object, +other);
        case $e65b35c84a7dc362$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e65b35c84a7dc362$var$regexpTag:
        case $e65b35c84a7dc362$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $e65b35c84a7dc362$var$mapTag:
            var convert = (0, $66uCe.default);
        case $e65b35c84a7dc362$var$setTag:
            var isPartial = bitmask & $e65b35c84a7dc362$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $eBtAy.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e65b35c84a7dc362$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $5k7WO.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $e65b35c84a7dc362$var$symbolTag:
            if ($e65b35c84a7dc362$var$symbolValueOf) return $e65b35c84a7dc362$var$symbolValueOf.call(object) == $e65b35c84a7dc362$var$symbolValueOf.call(other);
    }
    return false;
}
var $e65b35c84a7dc362$export$2e2bcd8739ae039 = $e65b35c84a7dc362$var$equalByTag;

});
parcelRegister("66uCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $471b0d3d26a123a7$export$2e2bcd8739ae039);
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $471b0d3d26a123a7$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $471b0d3d26a123a7$export$2e2bcd8739ae039 = $471b0d3d26a123a7$var$mapToArray;

});

parcelRegister("eBtAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa1b790e15273fb4$export$2e2bcd8739ae039);
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $aa1b790e15273fb4$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $aa1b790e15273fb4$export$2e2bcd8739ae039 = $aa1b790e15273fb4$var$setToArray;

});


parcelRegister("dxYwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcd4d8a0780abe9$export$2e2bcd8739ae039);

var $bZZOu = parcelRequire("bZZOu");
/** Used to compose bitmasks for value comparisons. */ var $9dcd4d8a0780abe9$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $9dcd4d8a0780abe9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9dcd4d8a0780abe9$var$hasOwnProperty = $9dcd4d8a0780abe9$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9dcd4d8a0780abe9$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9dcd4d8a0780abe9$var$COMPARE_PARTIAL_FLAG, objProps = (0, $bZZOu.default)(object), objLength = objProps.length, othProps = (0, $bZZOu.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $9dcd4d8a0780abe9$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $9dcd4d8a0780abe9$export$2e2bcd8739ae039 = $9dcd4d8a0780abe9$var$equalObjects;

});




parcelRegister("fp1Tt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b36aa8dae9fa5d84$export$2e2bcd8739ae039);
$parcel$export(module.exports, "blockDelta", () => $b36aa8dae9fa5d84$export$992ff47219af5a2b);
$parcel$export(module.exports, "BlockEmbed", () => $b36aa8dae9fa5d84$export$48b9f0688962d028);
$parcel$export(module.exports, "bubbleFormats", () => $b36aa8dae9fa5d84$export$e4bb5a6163449612);

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $bmwCM = parcelRequire("bmwCM");

var $fWwa7 = parcelRequire("fWwa7");

var $bxVMH = parcelRequire("bxVMH");
const $b36aa8dae9fa5d84$var$NEWLINE_LENGTH = 1;
class $b36aa8dae9fa5d84$export$2e2bcd8739ae039 extends (0, $lHwOS.BlockBlot) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $b36aa8dae9fa5d84$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $lHwOS.Scope).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $bmwCM.default)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $b36aa8dae9fa5d84$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $b36aa8dae9fa5d84$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.blotName = 'block';
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.tagName = 'P';
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.defaultChild = (0, $bmwCM.default);
$b36aa8dae9fa5d84$export$2e2bcd8739ae039.allowedChildren = [
    (0, $bmwCM.default),
    (0, $fWwa7.default),
    (0, $lHwOS.EmbedBlot),
    (0, $bxVMH.default)
];
class $b36aa8dae9fa5d84$export$48b9f0688962d028 extends (0, $lHwOS.EmbedBlot) {
    attach() {
        super.attach();
        this.attributes = new (0, $lHwOS.AttributorStore)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $lHwOS.Scope).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($b36aa8dae9fa5d84$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$b36aa8dae9fa5d84$export$48b9f0688962d028.scope = (0, $lHwOS.Scope).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $b36aa8dae9fa5d84$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $lHwOS.LeafBlot)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $b36aa8dae9fa5d84$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()).insert('\n', $b36aa8dae9fa5d84$export$e4bb5a6163449612(blot));
}
function $b36aa8dae9fa5d84$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $b36aa8dae9fa5d84$export$e4bb5a6163449612(blot.parent, formats, filter);
}

});
parcelRegister("bmwCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $845b0e4f439932ae$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
class $845b0e4f439932ae$var$Break extends (0, $lHwOS.EmbedBlot) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$845b0e4f439932ae$var$Break.blotName = 'break';
$845b0e4f439932ae$var$Break.tagName = 'BR';
var $845b0e4f439932ae$export$2e2bcd8739ae039 = $845b0e4f439932ae$var$Break;

});

parcelRegister("fWwa7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b5388c87c2e1a4$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $bmwCM = parcelRequire("bmwCM");

var $bxVMH = parcelRequire("bxVMH");
class $b9b5388c87c2e1a4$var$Inline extends (0, $lHwOS.InlineBlot) {
    static allowedChildren = [
        $b9b5388c87c2e1a4$var$Inline,
        (0, $bmwCM.default),
        (0, $lHwOS.EmbedBlot),
        (0, $bxVMH.default)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $b9b5388c87c2e1a4$var$Inline.order.indexOf(self);
        const otherIndex = $b9b5388c87c2e1a4$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($b9b5388c87c2e1a4$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $lHwOS.Scope).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $b9b5388c87c2e1a4$var$Inline && $b9b5388c87c2e1a4$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $b9b5388c87c2e1a4$export$2e2bcd8739ae039 = $b9b5388c87c2e1a4$var$Inline;

});
parcelRegister("bxVMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $867f998ee7d46ca2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "escapeText", () => $867f998ee7d46ca2$export$96e6fc3a139b2555);

var $lHwOS = parcelRequire("lHwOS");
class $867f998ee7d46ca2$export$2e2bcd8739ae039 extends (0, $lHwOS.TextBlot) {
}
// https://lodash.com/docs#escape
const $867f998ee7d46ca2$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $867f998ee7d46ca2$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$867f998ee7d46ca2$var$entityMap[s]);
}

});



parcelRegister("luQs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa65164eb3dea7d2$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $bxVMH = parcelRequire("bxVMH");
class $fa65164eb3dea7d2$var$Cursor extends (0, $lHwOS.EmbedBlot) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($fa65164eb3dea7d2$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $lHwOS.Scope).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $fa65164eb3dea7d2$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $fa65164eb3dea7d2$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $bxVMH.default) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $bxVMH.default) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($fa65164eb3dea7d2$var$Cursor.CONTENTS).join('');
        textNode.data = $fa65164eb3dea7d2$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $fa65164eb3dea7d2$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $fa65164eb3dea7d2$export$2e2bcd8739ae039 = $fa65164eb3dea7d2$var$Cursor;

});

parcelRegister("3EdO3", function(module, exports) {

$parcel$export(module.exports, "Range", () => $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c);
$parcel$export(module.exports, "default", () => $2a7fd1325c8b4c35$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $kaYY4 = parcelRequire("kaYY4");
var $d7fWe = parcelRequire("d7fWe");

var $jJqnr = parcelRequire("jJqnr");

var $lkbqq = parcelRequire("lkbqq");
const $2a7fd1325c8b4c35$var$debug = (0, $lkbqq.default)('quill:selection');
class $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $2a7fd1325c8b4c35$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $jJqnr.default).sources.USER), 1);
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $jJqnr.default).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $jJqnr.default).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $jJqnr.default).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $jJqnr.default).sources.SILENT);
            }
        });
        this.update((0, $jJqnr.default).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $jJqnr.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $jJqnr.default).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $jJqnr.default).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $lHwOS.Scope).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $lHwOS.LeafBlot)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $2a7fd1325c8b4c35$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $2a7fd1325c8b4c35$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $lHwOS.LeafBlot)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $2a7fd1325c8b4c35$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$2a7fd1325c8b4c35$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$2a7fd1325c8b4c35$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $2a7fd1325c8b4c35$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $jJqnr.default).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $2a7fd1325c8b4c35$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $jJqnr.default).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $d7fWe.default)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $jJqnr.default).events.SELECTION_CHANGE,
                (0, $kaYY4.default)(this.lastRange),
                (0, $kaYY4.default)(oldRange),
                source
            ];
            this.emitter.emit((0, $jJqnr.default).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $jJqnr.default).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $2a7fd1325c8b4c35$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $2a7fd1325c8b4c35$export$2e2bcd8739ae039 = $2a7fd1325c8b4c35$var$Selection;

});
parcelRegister("jJqnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d6ae3fc671a64c$export$2e2bcd8739ae039);

var $9DR0g = parcelRequire("9DR0g");

var $bp7pN = parcelRequire("bp7pN");

var $lkbqq = parcelRequire("lkbqq");
const $e5d6ae3fc671a64c$var$debug = (0, $lkbqq.default)('quill:events');
const $e5d6ae3fc671a64c$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$e5d6ae3fc671a64c$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $bp7pN.default).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $e5d6ae3fc671a64c$var$Emitter extends (0, $9DR0g.EventEmitter) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $e5d6ae3fc671a64c$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $e5d6ae3fc671a64c$var$debug.log.call($e5d6ae3fc671a64c$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $e5d6ae3fc671a64c$export$2e2bcd8739ae039 = $e5d6ae3fc671a64c$var$Emitter;

});
parcelRegister("9DR0g", function(module, exports) {
'use strict';
var $7050dee46d134475$var$has = Object.prototype.hasOwnProperty, $7050dee46d134475$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7050dee46d134475$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7050dee46d134475$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7050dee46d134475$var$Events().__proto__) $7050dee46d134475$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7050dee46d134475$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7050dee46d134475$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $7050dee46d134475$var$EE(fn, context || emitter, once), evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7050dee46d134475$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7050dee46d134475$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7050dee46d134475$var$EventEmitter() {
    this._events = new $7050dee46d134475$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7050dee46d134475$var$has.call(events, name)) names.push($7050dee46d134475$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7050dee46d134475$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7050dee46d134475$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7050dee46d134475$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7050dee46d134475$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7050dee46d134475$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7050dee46d134475$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7050dee46d134475$var$prefix ? $7050dee46d134475$var$prefix + event : event;
        if (this._events[evt]) $7050dee46d134475$var$clearEvent(this, evt);
    } else {
        this._events = new $7050dee46d134475$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7050dee46d134475$var$EventEmitter.prototype.off = $7050dee46d134475$var$EventEmitter.prototype.removeListener;
$7050dee46d134475$var$EventEmitter.prototype.addListener = $7050dee46d134475$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7050dee46d134475$var$EventEmitter.prefixed = $7050dee46d134475$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7050dee46d134475$var$EventEmitter.EventEmitter = $7050dee46d134475$var$EventEmitter;
module.exports = $7050dee46d134475$var$EventEmitter;

});

parcelRegister("bp7pN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d7c7fe096604f2$export$2e2bcd8739ae039);
var $84d7c7fe096604f2$export$2e2bcd8739ae039 = new WeakMap();

});

parcelRegister("lkbqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f864540b2feddf9d$export$2e2bcd8739ae039);
const $f864540b2feddf9d$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $f864540b2feddf9d$var$level = 'warn';
function $f864540b2feddf9d$var$debug(method) {
    if ($f864540b2feddf9d$var$level) {
        if ($f864540b2feddf9d$var$levels.indexOf(method) <= $f864540b2feddf9d$var$levels.indexOf($f864540b2feddf9d$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $f864540b2feddf9d$var$namespace(ns) {
    return $f864540b2feddf9d$var$levels.reduce((logger, method)=>{
        logger[method] = $f864540b2feddf9d$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$f864540b2feddf9d$var$namespace.level = (newLevel)=>{
    $f864540b2feddf9d$var$level = newLevel;
};
$f864540b2feddf9d$var$debug.level = $f864540b2feddf9d$var$namespace.level;
var $f864540b2feddf9d$export$2e2bcd8739ae039 = $f864540b2feddf9d$var$namespace;

});




parcelRegister("5APNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $41287d67a7596657$export$2e2bcd8739ae039);
class $41287d67a7596657$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $41287d67a7596657$export$2e2bcd8739ae039 = $41287d67a7596657$var$Module;

});

parcelRegister("gjzF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $be0a1534024d898e$export$2e2bcd8739ae039);

var $9xp90 = parcelRequire("9xp90");

var $jJqnr = parcelRequire("jJqnr");
class $be0a1534024d898e$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $9xp90.default))) {
            this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $jJqnr.default).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $be0a1534024d898e$export$2e2bcd8739ae039 = $be0a1534024d898e$var$Composition;

});
parcelRegister("9xp90", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1ab34356e15cb9$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $bxVMH = parcelRequire("bxVMH");
const $6f1ab34356e15cb9$var$GUARD_TEXT = '\uFEFF';
class $6f1ab34356e15cb9$var$Embed extends (0, $lHwOS.EmbedBlot) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($6f1ab34356e15cb9$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($6f1ab34356e15cb9$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($6f1ab34356e15cb9$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $bxVMH.default)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $bxVMH.default)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $6f1ab34356e15cb9$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $6f1ab34356e15cb9$export$2e2bcd8739ae039 = $6f1ab34356e15cb9$var$Embed;

});


parcelRegister("c7e5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2111f23e262436$export$2e2bcd8739ae039);
class $8d2111f23e262436$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $8d2111f23e262436$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $8d2111f23e262436$export$2e2bcd8739ae039 = $8d2111f23e262436$var$Theme;

});

parcelRegister("bb4Dz", function(module, exports) {

$parcel$export(module.exports, "default", () => $823451a7fecc8999$export$2e2bcd8739ae039);
const $823451a7fecc8999$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $823451a7fecc8999$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $823451a7fecc8999$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $823451a7fecc8999$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $823451a7fecc8999$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $823451a7fecc8999$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $823451a7fecc8999$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingLeft), $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $823451a7fecc8999$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingTop), $823451a7fecc8999$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $823451a7fecc8999$var$getParentElement(current);
    }
};
var $823451a7fecc8999$export$2e2bcd8739ae039 = $823451a7fecc8999$var$scrollRectIntoView;

});

parcelRegister("f3rcF", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5c3cdcba8d8c24$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
const $af5c3cdcba8d8c24$var$MAX_REGISTER_ITERATIONS = 100;
const $af5c3cdcba8d8c24$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $af5c3cdcba8d8c24$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $lHwOS.Registry)();
    $af5c3cdcba8d8c24$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $af5c3cdcba8d8c24$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $af5c3cdcba8d8c24$export$2e2bcd8739ae039 = $af5c3cdcba8d8c24$var$createRegistryWithFormats;

});


parcelRegister("em4Pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a736dcfb1334b50a$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
class $a736dcfb1334b50a$var$Container extends (0, $lHwOS.ContainerBlot) {
}
var $a736dcfb1334b50a$export$2e2bcd8739ae039 = $a736dcfb1334b50a$var$Container;

});

parcelRegister("03ycQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0002c14cbd5a5c37$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $jJqnr = parcelRequire("jJqnr");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $em4Pe = parcelRequire("em4Pe");
function $0002c14cbd5a5c37$var$isLine(blot) {
    return blot instanceof (0, $fp1Tt.default) || blot instanceof (0, $fp1Tt.BlockEmbed);
}
function $0002c14cbd5a5c37$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $0002c14cbd5a5c37$var$Scroll extends (0, $lHwOS.ScrollBlot) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $fp1Tt.default);
    static allowedChildren = [
        (0, $fp1Tt.default),
        (0, $fp1Tt.BlockEmbed),
        (0, $em4Pe.default)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $jJqnr.default).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $jJqnr.default).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $jJqnr.default).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $fp1Tt.BlockEmbed) || last instanceof (0, $fp1Tt.BlockEmbed)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $bmwCM.default) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $lHwOS.Scope).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $lHwOS.Scope).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $fp1Tt.BlockEmbed), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert({
                [first.key]: first.value
            });
            $0002c14cbd5a5c37$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $fp1Tt.bubbleFormats)(this.line(index)[0]);
            const attributes = (0, $kEXGb.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $0002c14cbd5a5c37$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $0002c14cbd5a5c37$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $lHwOS.LeafBlot) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($0002c14cbd5a5c37$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($0002c14cbd5a5c37$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $lHwOS.ContainerBlot)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $jJqnr.default).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $jJqnr.default).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$0002c14cbd5a5c37$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $jJqnr.default).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $jJqnr.default).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $fp1Tt.BlockEmbed), index);
        if (blot && blot.statics.blotName === key && $0002c14cbd5a5c37$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $lHwOS.Scope).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $lHwOS.Scope).BLOCK & (0, $lHwOS.Scope).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $0002c14cbd5a5c37$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $kEXGb.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $lHwOS.LeafBlot), index);
                const formats = (0, $fp1Tt.bubbleFormats)(leaf);
                attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $lHwOS.Scope).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $lHwOS.LeafBlot), index);
                    const formats = (0, $fp1Tt.bubbleFormats)(leaf);
                    attributes = (0, $kEXGb.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $0002c14cbd5a5c37$export$2e2bcd8739ae039 = $0002c14cbd5a5c37$var$Scroll;

});

parcelRegister("lkNmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f881c0971119051e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "traverse", () => $f881c0971119051e$export$df3f009e3d155b20);

var $lHwOS = parcelRequire("lHwOS");

var $kEXGb = parcelRequire("kEXGb");

var $fp1Tt = parcelRequire("fp1Tt");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");

var $dFEOL = parcelRequire("dFEOL");

var $5BkkP = parcelRequire("5BkkP");

var $gwsDR = parcelRequire("gwsDR");

var $4x8BI = parcelRequire("4x8BI");

var $iWFzb = parcelRequire("iWFzb");

var $kvjOh = parcelRequire("kvjOh");

var $jI3be = parcelRequire("jI3be");

var $lRlaz = parcelRequire("lRlaz");

var $fYOV4 = parcelRequire("fYOV4");
const $f881c0971119051e$var$debug = (0, $lkbqq.default)('quill:clipboard');
const $f881c0971119051e$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $f881c0971119051e$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $f881c0971119051e$export$c695b9637111f586
    ],
    [
        'br',
        $f881c0971119051e$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $f881c0971119051e$var$matchStyles
    ],
    [
        'li',
        $f881c0971119051e$var$matchIndent
    ],
    [
        'ol, ul',
        $f881c0971119051e$var$matchList
    ],
    [
        'pre',
        $f881c0971119051e$var$matchCodeBlock
    ],
    [
        'tr',
        $f881c0971119051e$var$matchTable
    ],
    [
        'b',
        $f881c0971119051e$var$createMatchAlias('bold')
    ],
    [
        'i',
        $f881c0971119051e$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $f881c0971119051e$var$createMatchAlias('strike')
    ],
    [
        'style',
        $f881c0971119051e$var$matchIgnore
    ]
];
const $f881c0971119051e$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $dFEOL.AlignAttribute),
    (0, $iWFzb.DirectionAttribute)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $f881c0971119051e$var$STYLE_ATTRIBUTORS = [
    (0, $dFEOL.AlignStyle),
    (0, $5BkkP.BackgroundStyle),
    (0, $4x8BI.ColorStyle),
    (0, $iWFzb.DirectionStyle),
    (0, $kvjOh.FontStyle),
    (0, $jI3be.SizeStyle)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $f881c0971119051e$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $f881c0971119051e$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $gwsDR.default).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text || '', {
            [(0, $gwsDR.default).blotName]: formats[(0, $gwsDR.default).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($f881c0971119051e$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $fYOV4.default)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $f881c0971119051e$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $lcQXp.default).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $lcQXp.default).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $lcQXp.default).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $lRlaz.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $f881c0971119051e$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $lcQXp.default).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $f881c0971119051e$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
}
function $f881c0971119051e$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $f881c0971119051e$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $lHwOS.EmbedBlot)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $f881c0971119051e$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$f881c0971119051e$var$isLine(node.previousElementSibling, scroll) && !$f881c0971119051e$var$isLine(node.nextElementSibling, scroll);
}
const $f881c0971119051e$var$preNodes = new WeakMap();
function $f881c0971119051e$var$isPre(node) {
    if (node == null) return false;
    if (!$f881c0971119051e$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $f881c0971119051e$var$preNodes.set(node, true);
        else $f881c0971119051e$var$preNodes.set(node, $f881c0971119051e$var$isPre(node.parentNode));
    }
    return $f881c0971119051e$var$preNodes.get(node);
}
function $f881c0971119051e$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $f881c0971119051e$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
}
function $f881c0971119051e$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $f881c0971119051e$var$applyFormat(delta, format, true, scroll);
    };
}
function $f881c0971119051e$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $lHwOS.Attributor).keys(node);
    const classes = (0, $lHwOS.ClassAttributor).keys(node);
    const styles = (0, $lHwOS.StyleAttributor).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $lHwOS.Scope).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $f881c0971119051e$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $f881c0971119051e$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $f881c0971119051e$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $f881c0971119051e$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $f881c0971119051e$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $lHwOS.EmbedBlot)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $lHwOS.BlockBlot) && !$f881c0971119051e$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $f881c0971119051e$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $f881c0971119051e$var$matchBreak(node, delta) {
    if (!$f881c0971119051e$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $f881c0971119051e$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $f881c0971119051e$var$applyFormat(delta, 'code-block', language, scroll);
}
function $f881c0971119051e$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))();
}
function $f881c0971119051e$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$f881c0971119051e$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
}
function $f881c0971119051e$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $f881c0971119051e$var$applyFormat(delta, 'list', list, scroll);
}
function $f881c0971119051e$export$c695b9637111f586(node, delta, scroll) {
    if (!$f881c0971119051e$var$deltaEndsWith(delta, '\n')) {
        if ($f881c0971119051e$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($f881c0971119051e$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $fp1Tt.BlockEmbed)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $f881c0971119051e$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $f881c0971119051e$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().insert('\t').concat(delta);
    return delta;
}
function $f881c0971119051e$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $f881c0971119051e$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $f881c0971119051e$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$f881c0971119051e$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$f881c0971119051e$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $f881c0971119051e$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $f881c0971119051e$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $f881c0971119051e$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $f881c0971119051e$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}

});
parcelRegister("dFEOL", function(module, exports) {

$parcel$export(module.exports, "AlignAttribute", () => $9f3ec447b9925575$export$2ef0f9fb04a51388);
$parcel$export(module.exports, "AlignClass", () => $9f3ec447b9925575$export$7f3685f5846c07da);
$parcel$export(module.exports, "AlignStyle", () => $9f3ec447b9925575$export$d2060f5d114c9fe8);

var $lHwOS = parcelRequire("lHwOS");
const $9f3ec447b9925575$var$config = {
    scope: (0, $lHwOS.Scope).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $9f3ec447b9925575$export$2ef0f9fb04a51388 = new (0, $lHwOS.Attributor)('align', 'align', $9f3ec447b9925575$var$config);
const $9f3ec447b9925575$export$7f3685f5846c07da = new (0, $lHwOS.ClassAttributor)('align', 'ql-align', $9f3ec447b9925575$var$config);
const $9f3ec447b9925575$export$d2060f5d114c9fe8 = new (0, $lHwOS.StyleAttributor)('align', 'text-align', $9f3ec447b9925575$var$config);

});

parcelRegister("5BkkP", function(module, exports) {

$parcel$export(module.exports, "BackgroundClass", () => $41402e8ca4b64635$export$8aa96c8963152b12);
$parcel$export(module.exports, "BackgroundStyle", () => $41402e8ca4b64635$export$dc1cbcab4c682ef);

var $lHwOS = parcelRequire("lHwOS");

var $4x8BI = parcelRequire("4x8BI");
const $41402e8ca4b64635$export$8aa96c8963152b12 = new (0, $lHwOS.ClassAttributor)('background', 'ql-bg', {
    scope: (0, $lHwOS.Scope).INLINE
});
const $41402e8ca4b64635$export$dc1cbcab4c682ef = new (0, $4x8BI.ColorAttributor)('background', 'background-color', {
    scope: (0, $lHwOS.Scope).INLINE
});

});
parcelRegister("4x8BI", function(module, exports) {

$parcel$export(module.exports, "ColorAttributor", () => $34d0ebb67a61d8bd$export$c992e3369f248f6e);
$parcel$export(module.exports, "ColorClass", () => $34d0ebb67a61d8bd$export$42795dcf0ec6f3c8);
$parcel$export(module.exports, "ColorStyle", () => $34d0ebb67a61d8bd$export$1415f56796d9a5a9);

var $lHwOS = parcelRequire("lHwOS");
class $34d0ebb67a61d8bd$export$c992e3369f248f6e extends (0, $lHwOS.StyleAttributor) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $34d0ebb67a61d8bd$export$42795dcf0ec6f3c8 = new (0, $lHwOS.ClassAttributor)('color', 'ql-color', {
    scope: (0, $lHwOS.Scope).INLINE
});
const $34d0ebb67a61d8bd$export$1415f56796d9a5a9 = new $34d0ebb67a61d8bd$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $lHwOS.Scope).INLINE
});

});


parcelRegister("gwsDR", function(module, exports) {

$parcel$export(module.exports, "CodeBlockContainer", () => $c075da2a83a1acdc$export$3b131632d3d15165);
$parcel$export(module.exports, "default", () => $c075da2a83a1acdc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Code", () => $c075da2a83a1acdc$export$52f0f02147b12c03);

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $luQs7 = parcelRequire("luQs7");

var $fWwa7 = parcelRequire("fWwa7");

var $bxVMH = parcelRequire("bxVMH");

var $em4Pe = parcelRequire("em4Pe");

var $lcQXp = parcelRequire("lcQXp");
class $c075da2a83a1acdc$export$3b131632d3d15165 extends (0, $em4Pe.default) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $bxVMH.escapeText)(this.code(index, length))}\n</pre>`;
    }
}
class $c075da2a83a1acdc$export$2e2bcd8739ae039 extends (0, $fp1Tt.default) {
    static TAB = '  ';
    static register() {
        (0, $lcQXp.default).register($c075da2a83a1acdc$export$3b131632d3d15165);
    }
}
class $c075da2a83a1acdc$export$52f0f02147b12c03 extends (0, $fWwa7.default) {
}
$c075da2a83a1acdc$export$52f0f02147b12c03.blotName = 'code';
$c075da2a83a1acdc$export$52f0f02147b12c03.tagName = 'CODE';
$c075da2a83a1acdc$export$2e2bcd8739ae039.blotName = 'code-block';
$c075da2a83a1acdc$export$2e2bcd8739ae039.className = 'ql-code-block';
$c075da2a83a1acdc$export$2e2bcd8739ae039.tagName = 'DIV';
$c075da2a83a1acdc$export$3b131632d3d15165.blotName = 'code-block-container';
$c075da2a83a1acdc$export$3b131632d3d15165.className = 'ql-code-block-container';
$c075da2a83a1acdc$export$3b131632d3d15165.tagName = 'DIV';
$c075da2a83a1acdc$export$3b131632d3d15165.allowedChildren = [
    $c075da2a83a1acdc$export$2e2bcd8739ae039
];
$c075da2a83a1acdc$export$2e2bcd8739ae039.allowedChildren = [
    (0, $bxVMH.default),
    (0, $bmwCM.default),
    (0, $luQs7.default)
];
$c075da2a83a1acdc$export$2e2bcd8739ae039.requiredContainer = $c075da2a83a1acdc$export$3b131632d3d15165;

});

parcelRegister("iWFzb", function(module, exports) {

$parcel$export(module.exports, "DirectionAttribute", () => $dcade2fe1940da51$export$4158215dafad9efa);
$parcel$export(module.exports, "DirectionClass", () => $dcade2fe1940da51$export$630028b3af294dec);
$parcel$export(module.exports, "DirectionStyle", () => $dcade2fe1940da51$export$175979e518d1dfd1);

var $lHwOS = parcelRequire("lHwOS");
const $dcade2fe1940da51$var$config = {
    scope: (0, $lHwOS.Scope).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $dcade2fe1940da51$export$4158215dafad9efa = new (0, $lHwOS.Attributor)('direction', 'dir', $dcade2fe1940da51$var$config);
const $dcade2fe1940da51$export$630028b3af294dec = new (0, $lHwOS.ClassAttributor)('direction', 'ql-direction', $dcade2fe1940da51$var$config);
const $dcade2fe1940da51$export$175979e518d1dfd1 = new (0, $lHwOS.StyleAttributor)('direction', 'direction', $dcade2fe1940da51$var$config);

});

parcelRegister("kvjOh", function(module, exports) {

$parcel$export(module.exports, "FontClass", () => $eed611c337a2b6c0$export$78a99ee601572ab);
$parcel$export(module.exports, "FontStyle", () => $eed611c337a2b6c0$export$23b468d4ca3f8c96);

var $lHwOS = parcelRequire("lHwOS");
const $eed611c337a2b6c0$var$config = {
    scope: (0, $lHwOS.Scope).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $eed611c337a2b6c0$export$78a99ee601572ab = new (0, $lHwOS.ClassAttributor)('font', 'ql-font', $eed611c337a2b6c0$var$config);
class $eed611c337a2b6c0$var$FontStyleAttributor extends (0, $lHwOS.StyleAttributor) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $eed611c337a2b6c0$export$23b468d4ca3f8c96 = new $eed611c337a2b6c0$var$FontStyleAttributor('font', 'font-family', $eed611c337a2b6c0$var$config);

});

parcelRegister("jI3be", function(module, exports) {

$parcel$export(module.exports, "SizeClass", () => $e59497eaff0bd080$export$c84684d52bca9684);
$parcel$export(module.exports, "SizeStyle", () => $e59497eaff0bd080$export$5443b95a30e89ac5);

var $lHwOS = parcelRequire("lHwOS");
const $e59497eaff0bd080$export$c84684d52bca9684 = new (0, $lHwOS.ClassAttributor)('size', 'ql-size', {
    scope: (0, $lHwOS.Scope).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $e59497eaff0bd080$export$5443b95a30e89ac5 = new (0, $lHwOS.StyleAttributor)('size', 'font-size', {
    scope: (0, $lHwOS.Scope).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});

});

parcelRegister("lRlaz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe9ef80dc5bc7156$export$2e2bcd8739ae039);
$parcel$export(module.exports, "deleteRange", () => $fe9ef80dc5bc7156$export$a6c813797f379898);

var $kaYY4 = parcelRequire("kaYY4");
var $d7fWe = parcelRequire("d7fWe");

var $kEXGb = parcelRequire("kEXGb");

var $lHwOS = parcelRequire("lHwOS");

var $lcQXp = parcelRequire("lcQXp");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");
const $fe9ef80dc5bc7156$var$debug = (0, $lkbqq.default)('quill:keyboard');
const $fe9ef80dc5bc7156$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $fe9ef80dc5bc7156$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $fe9ef80dc5bc7156$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $fe9ef80dc5bc7156$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$fe9ef80dc5bc7156$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $lcQXp.default).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $lHwOS.TextBlot) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $lHwOS.TextBlot) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $d7fWe.default)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $kEXGb.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $kEXGb.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $fe9ef80dc5bc7156$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $lHwOS.Scope).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
        this.quill.focus();
    }
}
const $fe9ef80dc5bc7156$var$defaultOptions = {
    bindings: {
        bold: $fe9ef80dc5bc7156$var$makeFormatHandler('bold'),
        italic: $fe9ef80dc5bc7156$var$makeFormatHandler('italic'),
        underline: $fe9ef80dc5bc7156$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $lcQXp.default).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $lcQXp.default).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $lcQXp.default).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $lcQXp.default).sources.USER);
            }
        },
        'indent code-block': $fe9ef80dc5bc7156$var$makeCodeBlockHandler(true),
        'outdent code-block': $fe9ef80dc5bc7156$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $lcQXp.default).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $lcQXp.default).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $lcQXp.default).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $lcQXp.default).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $fe9ef80dc5bc7156$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $lcQXp.default).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                        this.quill.setSelection(index, (0, $lcQXp.default).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $lcQXp.default).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $lcQXp.default).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $lcQXp.default).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $lcQXp.default).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $lcQXp.default).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $fe9ef80dc5bc7156$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $fe9ef80dc5bc7156$var$makeTableArrowHandler(false),
        'table up': $fe9ef80dc5bc7156$var$makeTableArrowHandler(true)
    }
};
$fe9ef80dc5bc7156$export$2e2bcd8739ae039.DEFAULTS = $fe9ef80dc5bc7156$var$defaultOptions;
function $fe9ef80dc5bc7156$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $lcQXp.default).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $lcQXp.default).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $lcQXp.default).sources.USER);
            this.quill.setSelection(index, length, (0, $lcQXp.default).sources.SILENT);
        }
    };
}
function $fe9ef80dc5bc7156$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $lHwOS.EmbedBlot))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $lcQXp.default).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $lcQXp.default).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $lcQXp.default).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $lcQXp.default).sources.USER);
            return false;
        }
    };
}
function $fe9ef80dc5bc7156$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $lcQXp.default).sources.USER);
        }
    };
}
function $fe9ef80dc5bc7156$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $lcQXp.default).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $lcQXp.default).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $lcQXp.default).sources.USER);
                }
            }
            return false;
        }
    };
}
function $fe9ef80dc5bc7156$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $kaYY4.default)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$fe9ef80dc5bc7156$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $fe9ef80dc5bc7156$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $kEXGb.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $lcQXp.default).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $lcQXp.default).sources.USER);
    quill.setSelection(range.index, (0, $lcQXp.default).sources.SILENT);
}
function $fe9ef80dc5bc7156$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}

});

parcelRegister("fYOV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba23f5278eaf5e5f$export$2e2bcd8739ae039);

var $44b6H = parcelRequire("44b6H");

var $jjvRV = parcelRequire("jjvRV");
const $ba23f5278eaf5e5f$var$NORMALIZERS = [
    (0, $jjvRV.default),
    (0, $44b6H.default)
];
const $ba23f5278eaf5e5f$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $ba23f5278eaf5e5f$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $ba23f5278eaf5e5f$export$2e2bcd8739ae039 = $ba23f5278eaf5e5f$var$normalizeExternalHTML;

});
parcelRegister("44b6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f6026c8dae984df$export$2e2bcd8739ae039);
const $2f6026c8dae984df$var$normalWeightRegexp = /font-weight:\s*normal/;
const $2f6026c8dae984df$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $2f6026c8dae984df$var$isBlockElement = (element)=>{
    return element && $2f6026c8dae984df$var$blockTagNames.includes(element.tagName);
};
const $2f6026c8dae984df$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$2f6026c8dae984df$var$isBlockElement(br.previousElementSibling) && $2f6026c8dae984df$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $2f6026c8dae984df$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($2f6026c8dae984df$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $2f6026c8dae984df$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $2f6026c8dae984df$var$normalizeFontWeight(doc);
        $2f6026c8dae984df$var$normalizeEmptyLines(doc);
    }
}

});

parcelRegister("jjvRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0f8832568fc71fd$export$2e2bcd8739ae039);
const $e0f8832568fc71fd$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $e0f8832568fc71fd$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $e0f8832568fc71fd$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $e0f8832568fc71fd$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($e0f8832568fc71fd$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($e0f8832568fc71fd$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $e0f8832568fc71fd$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($e0f8832568fc71fd$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$e0f8832568fc71fd$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $e0f8832568fc71fd$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $e0f8832568fc71fd$var$normalizeListItem(doc);
}

});



parcelRegister("jrSqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e28ac1ce11304a79$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");
class $e28ac1ce11304a79$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $lcQXp.default).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $lcQXp.default).events.SELECTION_CHANGE) {
                if (value && source !== (0, $lcQXp.default).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $lcQXp.default).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $lcQXp.default).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $e28ac1ce11304a79$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $e28ac1ce11304a79$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $lcQXp.default).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $e28ac1ce11304a79$var$transformStack(this.stack.undo, delta);
        $e28ac1ce11304a79$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $lcQXp.default).sources.USER);
        else {
            const index = $e28ac1ce11304a79$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $lcQXp.default).sources.USER);
        }
    }
}
function $e28ac1ce11304a79$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $e28ac1ce11304a79$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $e28ac1ce11304a79$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $lHwOS.Scope).BLOCK) != null;
    });
    return false;
}
function $e28ac1ce11304a79$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($e28ac1ce11304a79$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $e28ac1ce11304a79$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}

});

parcelRegister("5OX8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $43cf7f2c6e4ad356$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $jJqnr = parcelRequire("jJqnr");

var $5APNb = parcelRequire("5APNb");
class $43cf7f2c6e4ad356$var$Uploader extends (0, $5APNb.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$43cf7f2c6e4ad356$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $jJqnr.default).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $jJqnr.default).sources.SILENT);
        });
    }
};
var $43cf7f2c6e4ad356$export$2e2bcd8739ae039 = $43cf7f2c6e4ad356$var$Uploader;

});

parcelRegister("ccFIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e26f6e12626ebd5$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");

var $lRlaz = parcelRequire("lRlaz");
const $8e26f6e12626ebd5$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $8e26f6e12626ebd5$var$Input extends (0, $5APNb.default) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $lcQXp.default).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $lRlaz.deleteRange)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index).insert(text, formats), (0, $lcQXp.default).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $lcQXp.default).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$8e26f6e12626ebd5$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $8e26f6e12626ebd5$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $8e26f6e12626ebd5$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $8e26f6e12626ebd5$export$2e2bcd8739ae039 = $8e26f6e12626ebd5$var$Input;

});

parcelRegister("7wMGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b14a9997c447c8$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $5APNb = parcelRequire("5APNb");

var $lcQXp = parcelRequire("lcQXp");
const $57b14a9997c447c8$var$isMac = /Mac/i.test(navigator.platform);
const $57b14a9997c447c8$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $57b14a9997c447c8$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($57b14a9997c447c8$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $57b14a9997c447c8$var$UINode extends (0, $5APNb.default) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $lHwOS.ParentBlot)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $lcQXp.default).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $57b14a9997c447c8$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $57b14a9997c447c8$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $lHwOS.ParentBlot)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $57b14a9997c447c8$export$2e2bcd8739ae039 = $57b14a9997c447c8$var$UINode;

});


parcelRegister("gdglj", function(module, exports) {

$parcel$export(module.exports, "default", () => $030bc8697e5992e9$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");
class $030bc8697e5992e9$var$IndentAttributor extends (0, $lHwOS.ClassAttributor) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $030bc8697e5992e9$var$IndentClass = new $030bc8697e5992e9$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $lHwOS.Scope).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $030bc8697e5992e9$export$2e2bcd8739ae039 = $030bc8697e5992e9$var$IndentClass;

});

parcelRegister("itw5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $d733d2629ce55f93$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");
class $d733d2629ce55f93$var$Blockquote extends (0, $fp1Tt.default) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $d733d2629ce55f93$export$2e2bcd8739ae039 = $d733d2629ce55f93$var$Blockquote;

});

parcelRegister("iqhNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d69874f3d54e87db$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");
class $d69874f3d54e87db$var$Header extends (0, $fp1Tt.default) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $d69874f3d54e87db$export$2e2bcd8739ae039 = $d69874f3d54e87db$var$Header;

});

parcelRegister("9tKZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e6b45c117fc3d8e$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");

var $em4Pe = parcelRequire("em4Pe");

var $lcQXp = parcelRequire("lcQXp");
class $6e6b45c117fc3d8e$export$122a2a667e12876b extends (0, $em4Pe.default) {
}
$6e6b45c117fc3d8e$export$122a2a667e12876b.blotName = 'list-container';
$6e6b45c117fc3d8e$export$122a2a667e12876b.tagName = 'OL';
class $6e6b45c117fc3d8e$export$2e2bcd8739ae039 extends (0, $fp1Tt.default) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $lcQXp.default).register($6e6b45c117fc3d8e$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$6e6b45c117fc3d8e$export$2e2bcd8739ae039.blotName = 'list';
$6e6b45c117fc3d8e$export$2e2bcd8739ae039.tagName = 'LI';
$6e6b45c117fc3d8e$export$122a2a667e12876b.allowedChildren = [
    $6e6b45c117fc3d8e$export$2e2bcd8739ae039
];
$6e6b45c117fc3d8e$export$2e2bcd8739ae039.requiredContainer = $6e6b45c117fc3d8e$export$122a2a667e12876b;

});

parcelRegister("do6DE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf2aa86229ae61c$export$2e2bcd8739ae039);

var $fWwa7 = parcelRequire("fWwa7");
class $9bf2aa86229ae61c$var$Bold extends (0, $fWwa7.default) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $9bf2aa86229ae61c$export$2e2bcd8739ae039 = $9bf2aa86229ae61c$var$Bold;

});

parcelRegister("8TA2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $679f6b75ec696ed0$export$2e2bcd8739ae039);

var $do6DE = parcelRequire("do6DE");
class $679f6b75ec696ed0$var$Italic extends (0, $do6DE.default) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $679f6b75ec696ed0$export$2e2bcd8739ae039 = $679f6b75ec696ed0$var$Italic;

});

parcelRegister("46cdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc132bd2f39661c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sanitize", () => $2fc132bd2f39661c$export$83d2e9e3e4ee39ed);

var $fWwa7 = parcelRequire("fWwa7");
class $2fc132bd2f39661c$export$2e2bcd8739ae039 extends (0, $fWwa7.default) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $2fc132bd2f39661c$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $2fc132bd2f39661c$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}

});

parcelRegister("8kCjH", function(module, exports) {

$parcel$export(module.exports, "default", () => $610de9df6c46ceb3$export$2e2bcd8739ae039);

var $fWwa7 = parcelRequire("fWwa7");
class $610de9df6c46ceb3$var$Script extends (0, $fWwa7.default) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $610de9df6c46ceb3$export$2e2bcd8739ae039 = $610de9df6c46ceb3$var$Script;

});

parcelRegister("jEYPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e500f00f0018d2cd$export$2e2bcd8739ae039);

var $do6DE = parcelRequire("do6DE");
class $e500f00f0018d2cd$var$Strike extends (0, $do6DE.default) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $e500f00f0018d2cd$export$2e2bcd8739ae039 = $e500f00f0018d2cd$var$Strike;

});

parcelRegister("jVKfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e82737837a146548$export$2e2bcd8739ae039);

var $fWwa7 = parcelRequire("fWwa7");
class $e82737837a146548$var$Underline extends (0, $fWwa7.default) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $e82737837a146548$export$2e2bcd8739ae039 = $e82737837a146548$var$Underline;

});

parcelRegister("2GSBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f59dd059b0b60d6$export$2e2bcd8739ae039);

var $9xp90 = parcelRequire("9xp90");
class $1f59dd059b0b60d6$var$Formula extends (0, $9xp90.default) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $1f59dd059b0b60d6$export$2e2bcd8739ae039 = $1f59dd059b0b60d6$var$Formula;

});

parcelRegister("3PWre", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cb377283139738e$export$2e2bcd8739ae039);

var $lHwOS = parcelRequire("lHwOS");

var $46cdq = parcelRequire("46cdq");
const $2cb377283139738e$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $2cb377283139738e$var$Image extends (0, $lHwOS.EmbedBlot) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $2cb377283139738e$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $46cdq.sanitize)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($2cb377283139738e$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $2cb377283139738e$export$2e2bcd8739ae039 = $2cb377283139738e$var$Image;

});

parcelRegister("5VZP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $45223b4307b9f638$export$2e2bcd8739ae039);

var $fp1Tt = parcelRequire("fp1Tt");

var $46cdq = parcelRequire("46cdq");
const $45223b4307b9f638$var$ATTRIBUTES = [
    'height',
    'width'
];
class $45223b4307b9f638$var$Video extends (0, $fp1Tt.BlockEmbed) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $45223b4307b9f638$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $46cdq.default).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($45223b4307b9f638$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $45223b4307b9f638$export$2e2bcd8739ae039 = $45223b4307b9f638$var$Video;

});

parcelRegister("3MRPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c1f9bdf283ee6af$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $lHwOS = parcelRequire("lHwOS");

var $fWwa7 = parcelRequire("fWwa7");

var $lcQXp = parcelRequire("lcQXp");

var $5APNb = parcelRequire("5APNb");

var $fp1Tt = parcelRequire("fp1Tt");

var $bmwCM = parcelRequire("bmwCM");

var $luQs7 = parcelRequire("luQs7");

var $bxVMH = parcelRequire("bxVMH");

var $gwsDR = parcelRequire("gwsDR");

var $lkNmd = parcelRequire("lkNmd");
const $2c1f9bdf283ee6af$var$TokenAttributor = new (0, $lHwOS.ClassAttributor)('code-token', 'hljs', {
    scope: (0, $lHwOS.Scope).INLINE
});
class $2c1f9bdf283ee6af$export$9460eee64f276be7 extends (0, $fWwa7.default) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $gwsDR.default).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $2c1f9bdf283ee6af$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $2c1f9bdf283ee6af$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $2c1f9bdf283ee6af$var$TokenAttributor.add(this.domNode, value);
        else {
            $2c1f9bdf283ee6af$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$2c1f9bdf283ee6af$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$2c1f9bdf283ee6af$export$9460eee64f276be7.blotName = 'code-token';
$2c1f9bdf283ee6af$export$9460eee64f276be7.className = 'ql-token';
class $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb extends (0, $gwsDR.default) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $2c1f9bdf283ee6af$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer extends (0, $gwsDR.CodeBlockContainer) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $fp1Tt.blockDelta)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName,
                            $2c1f9bdf283ee6af$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $bxVMH.escapeText)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer.allowedChildren = [
    $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb
];
$2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.requiredContainer = $2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer;
$2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.allowedChildren = [
    $2c1f9bdf283ee6af$export$9460eee64f276be7,
    (0, $luQs7.default),
    (0, $bxVMH.default),
    (0, $bmwCM.default)
];
const $2c1f9bdf283ee6af$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $2c1f9bdf283ee6af$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    static register() {
        (0, $lcQXp.default).register($2c1f9bdf283ee6af$export$9460eee64f276be7, true);
        (0, $lcQXp.default).register($2c1f9bdf283ee6af$export$6c415d1fdae3dfdb, true);
        (0, $lcQXp.default).register($2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $lcQXp.default).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $2c1f9bdf283ee6af$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $lcQXp.default).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $lcQXp.default).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($2c1f9bdf283ee6af$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $lcQXp.default).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $lcQXp.default).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $bxVMH.escapeText)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $gwsDR.default).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $gwsDR.default).className);
        container.innerHTML = $2c1f9bdf283ee6af$var$highlight(this.options.hljs, language, text);
        return (0, $lkNmd.traverse)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $2c1f9bdf283ee6af$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(delta.length(), {
                    [$2c1f9bdf283ee6af$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $gwsDR.default).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$2c1f9bdf283ee6af$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};

});

parcelRegister("gkzBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3a21ff81941f4a$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $lcQXp = parcelRequire("lcQXp");

var $5APNb = parcelRequire("5APNb");

var $gPzxH = parcelRequire("gPzxH");
class $be3a21ff81941f4a$var$Table extends (0, $5APNb.default) {
    static register() {
        (0, $lcQXp.default).register((0, $gPzxH.TableCell));
        (0, $lcQXp.default).register((0, $gPzxH.TableRow));
        (0, $lcQXp.default).register((0, $gPzxH.TableBody));
        (0, $lcQXp.default).register((0, $gPzxH.TableContainer));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $gPzxH.TableContainer)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $lcQXp.default).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $lcQXp.default).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $lcQXp.default).sources.USER);
        this.quill.setSelection(offset, (0, $lcQXp.default).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $gPzxH.TableCell).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $lcQXp.default).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $lcQXp.default).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $lcQXp.default).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $lcQXp.default).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $lcQXp.default).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $gPzxH.tableId)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))().retain(range.index));
        this.quill.updateContents(delta, (0, $lcQXp.default).sources.USER);
        this.quill.setSelection(range.index, (0, $lcQXp.default).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $lcQXp.default).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $lcQXp.default).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $lcQXp.default).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $be3a21ff81941f4a$export$2e2bcd8739ae039 = $be3a21ff81941f4a$var$Table;

});
parcelRegister("gPzxH", function(module, exports) {

$parcel$export(module.exports, "TableCell", () => $c40cfac39da1a7c0$export$1e4baea7053fc0e3);
$parcel$export(module.exports, "tableId", () => $c40cfac39da1a7c0$export$9bd6f73cbe857f1b);
$parcel$export(module.exports, "TableRow", () => $c40cfac39da1a7c0$export$b05581f4e764e162);
$parcel$export(module.exports, "TableBody", () => $c40cfac39da1a7c0$export$76ccd210b9029917);
$parcel$export(module.exports, "TableContainer", () => $c40cfac39da1a7c0$export$f2c3aea42b2a048f);

var $fp1Tt = parcelRequire("fp1Tt");

var $em4Pe = parcelRequire("em4Pe");
class $c40cfac39da1a7c0$export$1e4baea7053fc0e3 extends (0, $fp1Tt.default) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $c40cfac39da1a7c0$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $c40cfac39da1a7c0$export$b05581f4e764e162 extends (0, $em4Pe.default) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $c40cfac39da1a7c0$export$76ccd210b9029917 extends (0, $em4Pe.default) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $c40cfac39da1a7c0$export$f2c3aea42b2a048f extends (0, $em4Pe.default) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($c40cfac39da1a7c0$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $c40cfac39da1a7c0$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($c40cfac39da1a7c0$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($c40cfac39da1a7c0$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $c40cfac39da1a7c0$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($c40cfac39da1a7c0$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $c40cfac39da1a7c0$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($c40cfac39da1a7c0$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($c40cfac39da1a7c0$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$c40cfac39da1a7c0$export$f2c3aea42b2a048f.allowedChildren = [
    $c40cfac39da1a7c0$export$76ccd210b9029917
];
$c40cfac39da1a7c0$export$76ccd210b9029917.requiredContainer = $c40cfac39da1a7c0$export$f2c3aea42b2a048f;
$c40cfac39da1a7c0$export$76ccd210b9029917.allowedChildren = [
    $c40cfac39da1a7c0$export$b05581f4e764e162
];
$c40cfac39da1a7c0$export$b05581f4e764e162.requiredContainer = $c40cfac39da1a7c0$export$76ccd210b9029917;
$c40cfac39da1a7c0$export$b05581f4e764e162.allowedChildren = [
    $c40cfac39da1a7c0$export$1e4baea7053fc0e3
];
$c40cfac39da1a7c0$export$1e4baea7053fc0e3.requiredContainer = $c40cfac39da1a7c0$export$b05581f4e764e162;
function $c40cfac39da1a7c0$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}

});


parcelRegister("lGJ7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca085890def0461$export$2e2bcd8739ae039);

var $kEXGb = parcelRequire("kEXGb");

var $lHwOS = parcelRequire("lHwOS");

var $lcQXp = parcelRequire("lcQXp");

var $lkbqq = parcelRequire("lkbqq");

var $5APNb = parcelRequire("5APNb");
const $fca085890def0461$var$debug = (0, $lkbqq.default)('quill:toolbar');
class $fca085890def0461$export$2e2bcd8739ae039 extends (0, $5APNb.default) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $fca085890def0461$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $fca085890def0461$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $lcQXp.default).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $fca085890def0461$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $lHwOS.EmbedBlot)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($kEXGb)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $lcQXp.default).sources.USER);
            } else this.quill.format(format, value, (0, $lcQXp.default).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$fca085890def0461$export$2e2bcd8739ae039.DEFAULTS = {};
function $fca085890def0461$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $fca085890def0461$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $fca085890def0461$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $fca085890def0461$var$addSelect(group, format, value);
                else $fca085890def0461$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $fca085890def0461$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$fca085890def0461$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $lHwOS.Scope).INLINE) != null) this.quill.format(name, false, (0, $lcQXp.default).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $lcQXp.default).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $lcQXp.default).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $lcQXp.default).sources.USER);
            this.quill.format('direction', value, (0, $lcQXp.default).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $lcQXp.default).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $lcQXp.default).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $lcQXp.default).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $lcQXp.default).sources.USER);
            } else this.quill.format('list', value, (0, $lcQXp.default).sources.USER);
        }
    }
};

});

parcelRegister("6tBRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b72d2854f1a515a$export$2e2bcd8739ae039);
const $4b72d2854f1a515a$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $4b72d2854f1a515a$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $4b72d2854f1a515a$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $4b72d2854f1a515a$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $4b72d2854f1a515a$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $4b72d2854f1a515a$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $4b72d2854f1a515a$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $4b72d2854f1a515a$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $4b72d2854f1a515a$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $4b72d2854f1a515a$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $4b72d2854f1a515a$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $4b72d2854f1a515a$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $4b72d2854f1a515a$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $4b72d2854f1a515a$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $4b72d2854f1a515a$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $4b72d2854f1a515a$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $4b72d2854f1a515a$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $4b72d2854f1a515a$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $4b72d2854f1a515a$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $4b72d2854f1a515a$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $4b72d2854f1a515a$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $4b72d2854f1a515a$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $4b72d2854f1a515a$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $4b72d2854f1a515a$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $4b72d2854f1a515a$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $4b72d2854f1a515a$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $4b72d2854f1a515a$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $4b72d2854f1a515a$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $4b72d2854f1a515a$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $4b72d2854f1a515a$export$2e2bcd8739ae039 = {
    align: {
        '': $4b72d2854f1a515a$var$alignLeftIcon,
        center: $4b72d2854f1a515a$var$alignCenterIcon,
        right: $4b72d2854f1a515a$var$alignRightIcon,
        justify: $4b72d2854f1a515a$var$alignJustifyIcon
    },
    background: $4b72d2854f1a515a$var$backgroundIcon,
    blockquote: $4b72d2854f1a515a$var$blockquoteIcon,
    bold: $4b72d2854f1a515a$var$boldIcon,
    clean: $4b72d2854f1a515a$var$cleanIcon,
    code: $4b72d2854f1a515a$var$codeIcon,
    'code-block': $4b72d2854f1a515a$var$codeIcon,
    color: $4b72d2854f1a515a$var$colorIcon,
    direction: {
        '': $4b72d2854f1a515a$var$directionLeftToRightIcon,
        rtl: $4b72d2854f1a515a$var$directionRightToLeftIcon
    },
    formula: $4b72d2854f1a515a$var$formulaIcon,
    header: {
        '1': $4b72d2854f1a515a$var$headerIcon,
        '2': $4b72d2854f1a515a$var$header2Icon,
        '3': $4b72d2854f1a515a$var$header3Icon,
        '4': $4b72d2854f1a515a$var$header4Icon,
        '5': $4b72d2854f1a515a$var$header5Icon,
        '6': $4b72d2854f1a515a$var$header6Icon
    },
    italic: $4b72d2854f1a515a$var$italicIcon,
    image: $4b72d2854f1a515a$var$imageIcon,
    indent: {
        '+1': $4b72d2854f1a515a$var$indentIcon,
        '-1': $4b72d2854f1a515a$var$outdentIcon
    },
    link: $4b72d2854f1a515a$var$linkIcon,
    list: {
        bullet: $4b72d2854f1a515a$var$listBulletIcon,
        check: $4b72d2854f1a515a$var$listCheckIcon,
        ordered: $4b72d2854f1a515a$var$listOrderedIcon
    },
    script: {
        sub: $4b72d2854f1a515a$var$subscriptIcon,
        super: $4b72d2854f1a515a$var$superscriptIcon
    },
    strike: $4b72d2854f1a515a$var$strikeIcon,
    table: $4b72d2854f1a515a$var$tableIcon,
    underline: $4b72d2854f1a515a$var$underlineIcon,
    video: $4b72d2854f1a515a$var$videoIcon
};

});

parcelRegister("h2pi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6763d99421400db$export$2e2bcd8739ae039);
const $c6763d99421400db$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $c6763d99421400db$var$optionsCounter = 0;
function $c6763d99421400db$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $c6763d99421400db$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $c6763d99421400db$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $c6763d99421400db$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $c6763d99421400db$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$c6763d99421400db$var$optionsCounter}`;
        $c6763d99421400db$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $c6763d99421400db$export$2e2bcd8739ae039 = $c6763d99421400db$var$Picker;

});

parcelRegister("hgZvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c933a5456c3d149b$export$2e2bcd8739ae039);

var $h2pi1 = parcelRequire("h2pi1");
class $c933a5456c3d149b$var$ColorPicker extends (0, $h2pi1.default) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $c933a5456c3d149b$export$2e2bcd8739ae039 = $c933a5456c3d149b$var$ColorPicker;

});

parcelRegister("5LEQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $433105be8edf3158$export$2e2bcd8739ae039);

var $h2pi1 = parcelRequire("h2pi1");
class $433105be8edf3158$var$IconPicker extends (0, $h2pi1.default) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $433105be8edf3158$export$2e2bcd8739ae039 = $433105be8edf3158$var$IconPicker;

});

parcelRegister("eeTZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ddcf577c721983$export$2e2bcd8739ae039);
const $a5ddcf577c721983$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $a5ddcf577c721983$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($a5ddcf577c721983$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $a5ddcf577c721983$export$2e2bcd8739ae039 = $a5ddcf577c721983$var$Tooltip;

});

parcelRegister("3FYBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad4356d8b023ab4$export$2e2bcd8739ae039);

var $4exCq = parcelRequire("4exCq");

var $jJqnr = parcelRequire("jJqnr");

var $3GeOH = parcelRequire("3GeOH");

var $3EdO3 = parcelRequire("3EdO3");

var $6tBRD = parcelRequire("6tBRD");

var $lcQXp = parcelRequire("lcQXp");
const $2ad4356d8b023ab4$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $2ad4356d8b023ab4$export$572b56f7a5e9813a extends (0, $3GeOH.BaseTooltip) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $jJqnr.default).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $jJqnr.default).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $jJqnr.default).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $3EdO3.Range)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $jJqnr.default).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $2ad4356d8b023ab4$export$2e2bcd8739ae039 extends (0, $3GeOH.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $2ad4356d8b023ab4$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $2ad4356d8b023ab4$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $6tBRD.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $6tBRD.default));
        }
    }
}
$2ad4356d8b023ab4$export$2e2bcd8739ae039.DEFAULTS = (0, $4exCq.default)({}, (0, $3GeOH.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $lcQXp.default).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});

});
parcelRegister("3GeOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae0c9a27889409a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseTooltip", () => $2ae0c9a27889409a$export$ba0102162f9e195c);

var $4exCq = parcelRequire("4exCq");

var $jJqnr = parcelRequire("jJqnr");

var $c7e5N = parcelRequire("c7e5N");

var $hgZvN = parcelRequire("hgZvN");

var $5LEQd = parcelRequire("5LEQd");

var $h2pi1 = parcelRequire("h2pi1");

var $eeTZS = parcelRequire("eeTZS");
const $2ae0c9a27889409a$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $2ae0c9a27889409a$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $2ae0c9a27889409a$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $2ae0c9a27889409a$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $2ae0c9a27889409a$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $2ae0c9a27889409a$export$2e2bcd8739ae039 extends (0, $c7e5N.default) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $5LEQd.default)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $hgZvN.default)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$FONTS);
                else if (select.classList.contains('ql-header')) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$HEADERS);
                else if (select.classList.contains('ql-size')) $2ae0c9a27889409a$var$fillSelect(select, $2ae0c9a27889409a$var$SIZES);
            }
            return new (0, $h2pi1.default)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $jJqnr.default).events.EDITOR_CHANGE, update);
    }
}
$2ae0c9a27889409a$export$2e2bcd8739ae039.DEFAULTS = (0, $4exCq.default)({}, (0, $c7e5N.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $2ae0c9a27889409a$export$ba0102162f9e195c extends (0, $eeTZS.default) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $jJqnr.default).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $jJqnr.default).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $2ae0c9a27889409a$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $jJqnr.default).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $jJqnr.default).sources.USER);
                        this.quill.setSelection(index + 2, (0, $jJqnr.default).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $2ae0c9a27889409a$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $2ae0c9a27889409a$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}

});


parcelRegister("j1VIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddaae11e905e3261$export$2e2bcd8739ae039);

var $4exCq = parcelRequire("4exCq");

var $jJqnr = parcelRequire("jJqnr");

var $3GeOH = parcelRequire("3GeOH");

var $46cdq = parcelRequire("46cdq");

var $3EdO3 = parcelRequire("3EdO3");

var $6tBRD = parcelRequire("6tBRD");

var $lcQXp = parcelRequire("lcQXp");
const $ddaae11e905e3261$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $ddaae11e905e3261$var$SnowTooltip extends (0, $3GeOH.BaseTooltip) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $jJqnr.default).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $jJqnr.default).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $jJqnr.default).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $46cdq.default), range.index);
                if (link != null) {
                    this.linkRange = new (0, $3EdO3.Range)(range.index - offset, link.length());
                    const preview = (0, $46cdq.default).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $ddaae11e905e3261$var$SnowTheme extends (0, $3GeOH.default) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $ddaae11e905e3261$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $6tBRD.default));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $6tBRD.default));
            // @ts-expect-error
            this.tooltip = new $ddaae11e905e3261$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$ddaae11e905e3261$var$SnowTheme.DEFAULTS = (0, $4exCq.default)({}, (0, $3GeOH.default).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $lcQXp.default).sources.USER);
                }
            }
        }
    }
});
var $ddaae11e905e3261$export$2e2bcd8739ae039 = $ddaae11e905e3261$var$SnowTheme;

});



//# sourceMappingURL=prsm.2a1c811c.js.map
